

// TODO consolidate to the same params for all bonuses, and use separate config for per bonus config from backend

import { TweenLite, TweenMax } from "gsap";
import { ClientState } from "../../../ClientState";

import { AddMouseDownListener, CreateElement, Filter, FilterFeatures, Log, LogGroup, Point, Rect, Scale, SetStyles, Size, TranslateScreen2To1 } from "../../.././MyHelpers";
import { AudioManager, Track } from "../../../AudioManager";
import { ISystemContext } from "../../../Context/SystemContext";
import { ITimeout } from "../../../Context/Timeout";
import { GameSession } from "../../../GameSession";
import { MyVideo } from "../../../MyVideo";
import { FontResource } from "../../../ResourceManager/FontResource";
import { DecodedImageResource, ImageResource } from "../../../ResourceManager/ImageResource";
import { Resourceful2 } from "../../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage } from "../../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../../ResourceManager/SpriteResource";
import { VideoResource2 } from "../../../ResourceManager/VideoResource";
import { RobotPlay } from "../../../RobotPlay";
import { MyCanvas } from "../../../slot/MyCanvas";
import { ScatterRandomAward, ScatterRandomAwardCreateParams, ScatterRandomAwardResults } from "../../../slot/ScatterRandomAward/ScatterRandomAward";
import { SlotFeature } from "../../../slot/SlotFeature";
import { SlotGameType1Shared } from "../../../slot/SlotGameType1Shared";
import { SlotSymbol } from "../../../slot/SlotSymbol";
import { ReelSymbolsToDisplay } from "../../../slot/SpinAnimation/ReelMapper";
import { SpinnableReelsParams } from "../../../slot/SpinAnimation/SpinnableReels";
import { S2_ReelMapper } from "../../../slot/SpinAnimation2/ReelMapper";
import { S2_ReelSetMapper } from "../../../slot/SpinAnimation2/ReelSetMapper";
import { S2_ReelSpinAnimation, S2_ReelSpinAnimParams } from "../../../slot/SpinAnimation2/ReelSpinAnimation";
import { S2_SpinAnimation } from "../../../slot/SpinAnimation2/SpinAnimation";
import { S2_IReelConfig } from "../../../slot/SpinAnimation2/SpinnableReels";
import { CanvasSprite } from "../../../slot/Sprite/CanvasSprite";
import { GetStateNameCallback, StateChange, StateMachine } from "../../../slot/StateMachine";
import { translationMap, Translator } from "../../../Translator";
//import { ZIndex } from "../../../ZIndex";
import { Panel } from "../../panel/panel";
import { BonusFinish, BonusPickElement, BonusPickReveal, BonusRevealRemaining, BonusTotalResult, IBonusStartConfig } from "../../SlotGame";
// import { SpinTargetParams } from "../../SpinAnimation/SpinTargetParams";
// import { S2_ReelSpinAnimationUpdateParams } from "../../SpinAnimation2/ReelSpinAnimation";
// import { ITransition } from "../../Transition/ITransition";
// import { ITransitionFactory, ITransitionParams } from "../../Transition/ITransitionFactory";
// import { TransitionFactory } from "../../Transition/TransitionFactory";
// import { LoadingItem } from "../LoadingItem";
import { AwardOptionPosition, AwardPositionWithValue, AwardType, IFeatureConfiguration, JackpotAwardOption, JackpotLevel, MultiBonusType, PlayWindow, ScatterRandomAwardConfiguration, ScatterRandomAwardResult, SimpleSlotGameState, SlotGameBet, SpinAndHoldCommonConfiguration, SpinAndHoldEndAction, SpinAndHoldSpinAction, SpinAndHoldStartAction } from "../../../api";
import { Money } from "../../../Money";
import { service } from "../../../services";
import { JackpotDisplayType, Presentation, Settings } from "../../../Settings";
import { ZIndex } from "../../../ZIndex";
import { SpinTargetParams } from "../../SpinAnimation/SpinTargetParams";
import { S2_ReelSpinAnimationUpdateParams } from "../../SpinAnimation2/ReelSpinAnimation";
import { ITransition } from "../../Transition/ITransition";
import { ITransitionFactory, ITransitionParams } from "../../Transition/ITransitionFactory";
import { TransitionFactory } from "../../Transition/TransitionFactory";
import { LoadingItem } from "../LoadingItem";
import { ConstructReelsParams, SlotBonus } from "../SlotBonus";
import { HoldingFeature, HoldingFeatureParams } from "./HoldingFeature";
import { SpinAndHoldMessages } from "./SpinAndHoldMessages";
import { SpinAndHoldParams } from "./SpinAndHoldParams";
import { SpinAndHoldRunResult } from "./SpinAndHoldRunResult";
import { SpinAndHoldSession } from "./SpinAndHoldSession";
import { SpinAndHoldState } from "./SpinAndHoldState";
// import { ITimeout } from "../../../Context/Timeout";
import * as PIXI from 'pixi.js';
import { assertNotNullish } from "../../../debug";
import { PixiSpriteResource } from "../../../ResourceManager/PixiSpriteResource";
import { JackpotValuesReset, ScreenProtocolScope } from "../../../ScreenProtocol";
import { CometFactory } from "../../CometFeature/CometFactory";
import { ICometFactory, ICometInterface } from "../../CometFeature/ICometInterface";
import { ActionStats, HistoryStats } from "../../IHistoyGame";
import { ScatterRandomAwardPIXI } from "../../ScatterRandomAward/ScatterRandomAwardPIXI";
import { ChangeSpeedParams } from "../../SlotGameType1";
import { S2_ISpinnableReelPIXI, S2_SpinnableReelsBigCanvas2 } from "../../SpinAnimation2/SpinnableReelsBigCanvas2";
import { JackpotDisplayProperties } from "../../../JackpotDisplayProperties";

export enum SpinAndHoldContainer {
	IntroMessage,
	Reels,
	FinalMessage
}

interface TextureDialogLanguage {
	textureBonusIntro : any;
	textureBonusFinal : any;
}

// export enum SpinAndHoldRecoveryAction {
// 	SpinAndHoldSpin = "SpinAndHoldSpin",
// 	BigSymbolSpinAndHoldSpin = "BigSymbolSpinAndHoldSpin",
// 	SpinAndHoldStart = "SpinAndHoldStart",
// 	BigSymbolSpinAndHoldStart = "BigSymbolSpinAndHoldStart"
// }

export class SpinAndHoldBonus extends SlotBonus implements Resourceful2 {
	public override OnResize(): void {
		throw new Error("Method not implemented.");
	}

	public override CreateTransitionPixi(app : PIXI.Container): void {
		//throw new Error("Method not implemented.");
		this.transitionView.CreateTransitionPixi(app);
	}
	public override DestroyTransition(): void {
		//throw new Error("Method not implemented.");
		this.transitionView.DestroyTransitionPixi();
	}
	protected params: SpinAndHoldParams = null;
	protected config: SpinAndHoldCommonConfiguration = null;
	protected view: HTMLElement = null;

	protected session: SpinAndHoldSession = null;

	protected introMessageContainer: HTMLElement = null;
	protected reelsContainer: HTMLElement = null;
	protected finalMessageContainer: HTMLElement = null;


	protected containers: Map<SpinAndHoldContainer, HTMLElement> = new Map<SpinAndHoldContainer, HTMLElement>();

	//protected pickElem: HTMLElement = null;

	//protected containers: HTMLElement[] = [];

	//private logGroup: string = "HoldAndSpin";
	protected stateMachine: StateMachine<SpinAndHoldState> = new StateMachine<SpinAndHoldState>(SpinAndHoldState.Idle, this.logGroup, (state: SpinAndHoldState) => SpinAndHoldState[state]);

	// REELS
	//protected spinnableReels: SpinnableReels = null;
	//protected spinAnimation: SpinAnimation = null;
	//protected reelSetMapper: ReelSetMapper = null;

	protected spinnableReels2: S2_SpinnableReelsBigCanvas2 = null;
	protected spinAnimation2: S2_SpinAnimation = null;
	protected reelSetMapper2: S2_ReelSetMapper = null;

	// WIN LINES AND MARKERS
	//private winLines: WinLines = null;
	//private winLinesAnimation: WinLinesAnimation = null;
	//private winLineMarkers: WinLineMarkers = null;

	// EXPANDING WILD FEATURE
	private features: Map<string, SlotFeature> = new Map<string, SlotFeature>();
	//private expandingWildsBulk: ExpandingWildsBulk = null;

	protected scatterRandomAwardFeature: ScatterRandomAwardPIXI = null;
	protected holdingFeature: HoldingFeature = null;
	//CHANGE COLOR FOR AWARD 
	//SEND COLOR 
	protected color: string = "white";
	protected coloroutherStroke: string = "black";
	protected colorinnerStroke: string = "red";



	// spin delay, in millis
	//private autoSpinTimer: SingleShotTimer= new SingleShotTimer(() => this.AutoSpin(), 3000);
	private autoSpinTimer: number = null;

	//
	protected lastSpinResult: SpinAndHoldRunResult = null;
	protected scatterPositions: AwardPositionWithValue[] = null;

	// win lines or colelct can be interrupted, 
	// when interrupted, start new spin right away 
	private spinInterrupted: boolean = false;

	protected winCreditAnimation: TweenMax = null;
	protected winValues: any = { balance: 0, win: 0 };

	//protected symbolsAnimation: SymbolsAnimation = null;

	//protected symbolsAnimation: SpecificSymbolsAnimation = null;

	//protected winMessageAnimation: WinMessageAnimation = null;
	//protected shakeAnimation: ShakeAnimation = null;
	//protected fountainAnimation: FountainAnimation = null;
	//protected bigWinCountAnimation: BigWinCountAnimation = null;

	protected panel: Panel;


	private lineMessage: HTMLElement = null;
	//private denomMessage: HTMLElement = null;

	//private transition: SceneTransition = null;

	protected audio: AudioManager = null;

	protected override parentresid: ResourceIdentifier = null;
	//protected resid: ResourceIdentifier = null;
	//protected screenProtocol: ScreenProtocol = null;
	//protected screenProtocolScope: ScreenProtocolScope = null;

	private lineMessageLeft: HTMLElement = null;
	private lineMessageRight: HTMLElement = null;

	//protected basegameWinCents: number = 0;

	protected clientState: ClientState = null;
	protected translator: Translator;

	protected robotPlay: RobotPlay;

	protected demoMessage: HTMLElement = null;

	//ADD VIDEO TRANSITION
	//protected transitionView:HTMLElement=null;
	//protected videotransition:HTMLVideoElement=null;

	//CREATE DIV TO TITLE 
	//protected titleSrpite:HTMLElement=null;
	//protected titleSprite: CanvasSprite = null;
	protected VoicePlay: boolean = true;

	protected spinnableReelsParams: SpinnableReelsParams = {};
	protected systemContext: ISystemContext = null;


	// protected wins: IWinMessage[] = [
	// 	{ name: "big", winMultiplier: 10, file: "big_win_966x185_half" },
	// 	{ name: "great", winMultiplier: 20, file: "great_win_1013x277_half" },
	// 	{ name: "huge", winMultiplier: 30, file: "huge_win_966x202_half" },
	// 	{ name: "awesome", winMultiplier: 40, file: "awesome_win_1119x213_half" },
	// 	{ name: "amazing", winMultiplier: 50, file: "amazing_win_1185x252_half" }
	// ];
	//protected grayScale: BlackAndWhiteSymbols = null;

	protected requiredSymbol: string = "SRA";


	// comet sprite to show
	//protected comet: Comet = null;

	protected commetFactory : ICometFactory = new CometFactory();
	protected commetView : ICometInterface = null;

	// index of the scatter, for which to show the comet
	protected currentScatterCometIndex: number = -1;
	
	//Create some canvas for button text dialog
	protected buttonStartCanvas: MyCanvas;
	protected buttonExitCanvas: MyCanvas;

	protected fontHeight:number=Scale.fh(135);
	protected fontFamily: string;

	protected TitleSpriteTransition: CanvasSprite = null;

    protected JackpotVideoResource:string=null;
	
	protected transitionView: ITransition = null;
	public get TransitionView(): ITransition {
		return this.transitionView;
	};
	protected transitionViewFactory:ITransitionFactory= new TransitionFactory();
	protected backgroundSpinHoldGame: HTMLElement = null;

	//Machine is locked 
	protected isLocked : boolean = false ; 


	protected BonusName(): string
	{
		return "SpinAndHold";
	}

	//create intervals anim 
	protected timeoutNextCommetCash: ITimeout = null;
	protected timeoutNextCommetJP1AndJP2: ITimeout = null;
	protected timeoutNextCommetJP3: ITimeout = null;
	protected timeoutNextCommetJP4: ITimeout = null;
	protected timeoutJP4ShowTime: ITimeout = null;
	protected timeoutJP3ShowTime: ITimeout = null;
	protected timeoutJP2AndJP1ShowTime: ITimeout = null;
	protected intervalvideoFadeOutTimer: ITimeout = null;
	protected intervalStopFountainTimer: ITimeout = null;
	protected timeoutFinalMessageState : ITimeout = null;
	protected timeoutStartCometCollect : ITimeout = null;
	protected timeoutSRAPlusOne : ITimeout = null;
	protected timeoutAutoSpin : ITimeout =  null;

	//protected bonusAppView : BonusAppPixi = null;

	protected loadingSequence: LoadingItem[] = [
		{Name: "Base",				Prepare: (r) => this.BasePrepare(r),				Loaded: (r) => this.BaseLoaded(r)},
		{Name: "Containers",		Prepare: null,										Loaded: (r) => null},
		{Name: "ViewAppBonus",		Prepare: (r)=> null,				Loaded: (r) => this.LoadedResourcesBonusViewApp(r)},
		{Name: "ReelBackground",	Prepare: (r) => this.PrepareBackgroundReel(r),		Loaded: null},
		// {Name: "Reel",				Prepare: (r) => this.ConstructReels2(r),			Loaded: (r) => this.ReelsLoaded(r)},
		{Name: "Audio",				Prepare: (r) => this.AudioPrepare(r),				Loaded: null},
		{Name: "Features",			Prepare: (r) => this.FeaturesPrepare(r),			Loaded: (r) => this.FeaturesLoaded(r)},
		{Name: "BigWin",			Prepare: (r) => this.BigWinPrepare(r),				Loaded: (r) => this.BigWinLoaded(r)},
		{Name: "History",			Prepare: (r) => this.PrepareHistory(r),				Loaded: (r) => this.LoadedHistory(r)},
		{Name: "Comets",			Prepare: (r) => this.CometsPrepare(r),				Loaded: (r) => this.CometsLoaded(r)},
		{Name: "Video",				Prepare: (r) => this.PrepareVideos(r),				Loaded: (r) => this.VideosLoaded(r)},
		{Name: "Demo",				Prepare: null,										Loaded: (r) => this.DemoLoaded(r)},
		{Name: "Display",			Prepare: null,										Loaded: (r) => this.HideAllContainers()},
		{Name: "TitleTransition",   Prepare: (r) => this.PrepareTransition(r),     		Loaded: (r) => this.TransitionLoaded(r)},
	];

	public constructor(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration) {
		super(gameName, params);

		this.params = params;
		this.config = config;  

		this.session = new SpinAndHoldSession("Screen-1");

		this.parentresid = params.resid;
		//this.translator=translator;
		this.translator = params.translator;

		//this.screenProtocol = params.screenProtocol;
		//this.screenProtocolScope = params.screenProtocolScope.Add("SpinAndHold");

		this.panel = params.panel;

		this.jackpotName = Settings.JackpotDisplayType;
if (JackpotDisplayProperties[Settings.JackpotDisplayType].alias) this.jackpotName = JackpotDisplayProperties[Settings.JackpotDisplayType].alias;

		this.audio = params.audio;
		this.clientState = params.clientState;
		this.systemContext = params.systemContext.CreateSubContext(this.bonusName);

		this.view = document.createElement("div");
		this.view.classList.add(this.resid.Scope());
		this.view.classList.add(this.bonusName);

		this.backgroundSpinHoldGame = CreateElement("div",{
			classes:[this.resid.Scope(), "BackgroundBonusGame"],
			parentToAppend: this.view,
			style: {
				width: "100%",
				height: Scale.Hpx(1080*this.ScreenNumberConfiguration),
				position: "absolute",
				bottom: Scale.Ypx(0),
				//backgroundColor: "red",
				//zIndex: ZIndex.backgroundBaseGame.toString(),
			}
		});

		this.lineMessage = document.createElement("div");
		this.lineMessage.classList.add("line-message");

		// TODO move to some common place?
		if (params.slotGameMeta.Demo == true) {
			//demo message
			this.demoMessage = document.createElement("div");
			this.demoMessage.classList.add("demo-message");
			SetStyles(this.demoMessage,
				{
					position: "absolute",
					top: Scale.Ypx(86),
					right: Scale.Xpx(0),
					width:  Scale.Wpx(307),
					height: Scale.Hpx(86),
					fontSize: Scale.fhpx(99),
					letterSpacing: Scale.fhpx(5),
					fontFamily: "NotoSansDisplay-ExtraBold",
					color: "rgba(255, 0, 0, 1)",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					transform: "rotate(45deg)",
					zIndex:ZIndex.DemoMessage.toString(),
				})

			this.demoMessage.innerHTML = "DEMO";
		}


		

		//this.denomMessage = document.createElement("div");
		//this.denomMessage.classList.add("denom-message");

		this.stateMachine.SetCallback(SpinAndHoldState.IntroTransition, StateChange.Begin, () => this.OnIntroTransitionBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.IntroTransition, StateChange.End, () => this.OnIntroTransitionEnd());

		this.stateMachine.SetCallback(SpinAndHoldState.IntroMessage, StateChange.Begin, () => this.OnIntroMessageBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.IntroMessage, StateChange.End, () => this.OnIntroMessageEnd());
	    void service.api?.registerOperation("MachineLock",   this.resid.ID(), (data) =>{this.isLocked= true;});
	    void service.api?.registerOperation("MachineUnlock", this.resid.ID(), () =>{this.isLocked= false;});
		

		// this.stateMachine.SetCallback(SpinAndHoldState.Pick, StateChange.Begin, () => this.OnPickBegin());
		//this.stateMachine.SetCallback(SpinAndHoldState.Pick, StateChange.End, () => this.OnPickEnd());

		// this.stateMachine.SetCallback(SpinAndHoldState.PickedMessage, StateChange.Begin, () => this.OnPickedMessageBegin());
		// this.stateMachine.SetCallback(SpinAndHoldState.PickedMessage, StateChange.End, () => this.OnPickedMessageEnd());
		//this.stateMachine.SetCallback(SpinAndHoldState.Running, StateChange.Begin, () => this.OnRunningBegin());

		this.stateMachine.SetCallback(SpinAndHoldState.WaitFirstSpin, StateChange.Begin, () => this.OnWaitFirstSpinBegin());
		//this.stateMachine.SetCallback(SpinAndHoldState.Spin, StateChange.End, () => this.OnSpinEnd());

		this.stateMachine.SetCallback(SpinAndHoldState.Spin, StateChange.Begin, () => this.OnSpinBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.Spin, StateChange.End, () => this.OnSpinEnd());

		this.stateMachine.SetCallback(SpinAndHoldState.Features, StateChange.Begin, () => this.OnFeaturesBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.Features, StateChange.End, () => this.OnFeaturesEnd());

		this.stateMachine.SetCallback(SpinAndHoldState.BigWin, StateChange.Begin, () => this.OnBigWinBegin());
		//this.stateMachine.SetCallback(SpinAndHoldState.BigWin, StateChange.End, () => this.OnBigWinEnd());

		this.stateMachine.SetCallback(SpinAndHoldState.Win, StateChange.Begin, () => this.OnWinBegin());
		//this.stateMachine.SetCallback(SpinAndHoldState.Win, StateChange.End, () => this.OnWinEnd());

		this.stateMachine.SetCallback(SpinAndHoldState.Collect, StateChange.Begin, () => this.OnCollectBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.SpinIdle, StateChange.Begin, () => this.OnSpinIdleBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.SpinIdle, StateChange.End, () => this.OnSpinIdleEnd());

		this.stateMachine.SetCallback(SpinAndHoldState.CometCollect, StateChange.Begin, () => this.OnCometCollectBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.CometCollect, StateChange.End, () => this.OnCometCollectEnd());


		this.stateMachine.SetCallback(SpinAndHoldState.FinalMessage, StateChange.Begin, () => this.OnFinalMessageBegin());
		this.stateMachine.SetCallback(SpinAndHoldState.FinalMessage, StateChange.End, () => this.OnFinalMessageEnd());	

		this.stateMachine.SetStateChangeCallback((oldState: SpinAndHoldState, newState: SpinAndHoldState, stateNameCallback: GetStateNameCallback<SpinAndHoldState>) => {
			// Log.Debug(this.logGroup, "Changing state " + stateNameCallback(oldState) + " to " + stateNameCallback(newState));
		});

		this.robotPlay = params.robotPlay;

		//commets interval 
		this.timeoutNextCommetCash = this.systemContext.TimingContext().CreateTimeout("timeoutNextCommetCash", 500, () => {
			this.NextComet();
		});
		this.timeoutNextCommetJP4 = this.systemContext.TimingContext().CreateTimeout("timeoutNextCommetJP4", 45000, () => {
			this.NextComet();
			this.StopFontain(JackpotLevel.Jp4);
		});
		this.timeoutNextCommetJP3 = this.systemContext.TimingContext().CreateTimeout("timeoutNextCommetJP3", 31000, () => {
			this.NextComet();
			this.StopFontain(JackpotLevel.Jp3);
		});
		this.timeoutNextCommetJP1AndJP2 = this.systemContext.TimingContext().CreateTimeout("timeoutNextCommetJP1AndJP2", 3200, () => {
			this.NextComet();
			this.StopFontain(this.scatterPositions[this.currentScatterCometIndex]?.AwardOptionPosition.AwardOption.AwardName as JackpotLevel);
		});
		//show time intervals
		this.timeoutJP4ShowTime = this.systemContext.TimingContext().CreateTimeout("timeoutJP4ShowTime", 500, () => this.StartShowWin(JackpotLevel.Jp4, 42000));
		this.timeoutJP3ShowTime = this.systemContext.TimingContext().CreateTimeout("timeoutJP3ShowTime", 500, () => this.StartShowWin(JackpotLevel.Jp3, 29000));
		this.timeoutJP2AndJP1ShowTime = this.systemContext.TimingContext().CreateTimeout("timeoutJP2AndJP1ShowTime", 500, () => this.StartShowWin(this.scatterPositions[this.currentScatterCometIndex]?.AwardOptionPosition.AwardOption.AwardName as JackpotLevel, 2500));
		this.timeoutJP3ShowTime = this.systemContext.TimingContext().CreateTimeout("timeoutJP3ShowTime", 500, () => this.StartShowWin(JackpotLevel.Jp3, 29000));
		this.timeoutFinalMessageState = this.systemContext.TimingContext().CreateTimeout("timeoutFinalMessageState", 700, () => {			
			this.stateMachine.ChangeState(SpinAndHoldState.FinalMessage)
		});
		this.timeoutStartCometCollect = this.systemContext.TimingContext().CreateTimeout("timeoutStartCometCollect",2500,()=>{
			this.stateMachine.ChangeState(SpinAndHoldState.CometCollect)
		});

		this.timeoutSRAPlusOne = this.systemContext.TimingContext().CreateTimeout("timeoutSRAPlusOne", 500, () => {
			this.stateMachine.ChangeState(SpinAndHoldState.BigWin);
			// send when animation is finished, move to separate timeout if necessary
			this.screenProtocol?.Send(new SpinAndHoldMessages.PlusMessage(this.session), this.screenProtocolScope);
		});

	    this.timeoutAutoSpin = this.systemContext.TimingContext().CreateTimeout("timeoutAutoSpin", 1000, () => { this.AutoSpin()});

		// on pressing key N call InternalNextComet
		window.addEventListener("keydown", (event) => {
			if (event.key.toLowerCase() == "n" )
			{
				this.InternalNextComet();
			}
		});

		
	}

	public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		for (let item of this.loadingSequence)
		{
			try
			{
				await item.Prepare?.(resourceManager);
			}
			catch (e)
			{
				debugger;
			}
				
		};
	}

	public async AudioPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> 
	{
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/background" + Settings.audioFormat, this.resid.ScopedResourceName("background")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/backgroundend" + Settings.audioFormat, this.resid.ScopedResourceName("backgroundend")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/transition" + Settings.audioFormat, this.resid.ScopedResourceName("transitionaudio")));
		//this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/pick" + Settings.audioFormat, this.resid.ScopedResourceName("pick")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/remaining" + Settings.audioFormat, this.resid.ScopedResourceName("remaining")));

		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/bonustriggered" + Settings.audioFormat, this.resid.ScopedResourceName("triggered")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/plusone" + Settings.audioFormat, this.resid.ScopedResourceName("plusone")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/final" + Settings.audioFormat, this.resid.ScopedResourceName("final")));
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/freegameintro" + Settings.audioFormat, this.resid.ScopedResourceName("intro")));
		//Load Voice Diamond POT
		this.audio.AddTrack(new Track(this.params.gameBonusResourcesBasePath + "tracks/freegame" + Settings.audioFormat, this.resid.ScopedResourceName("freegame")));



		

		if ( Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay)
		{
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/"+this.jackpotName+"-WinVoice/jp3Win" + Settings.audioFormat, this.resid.ScopedResourceName("jp3Voice")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/"+this.jackpotName+"-WinVoice/jp4Win" + Settings.audioFormat, this.resid.ScopedResourceName("jp4Voice")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/"+this.jackpotName+"-WinVoice/jp2Win" + Settings.audioFormat, this.resid.ScopedResourceName("jp2Voice")));
			this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/"+this.jackpotName+"-WinVoice/jp1Win" + Settings.audioFormat, this.resid.ScopedResourceName("jp1Voice")));			
		}		
		else{
			throw `Spin And Hold Its Not implemented for AudioPrepare ${Settings.JackpotDisplayType}`;
		}


		
		//load jackpot sound effect
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/Emeraldwin" + Settings.audioFormat, this.resid.ScopedResourceName("jp1Background")));
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/Emeraldwin" + Settings.audioFormat, this.resid.ScopedResourceName("jp2Background")));
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/Rubywin" + Settings.audioFormat, this.resid.ScopedResourceName("jp3Background")));
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/Diamondwinfull" + Settings.audioFormat, this.resid.ScopedResourceName("jp4Background")));		
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/clasploop" + Settings.audioFormat, this.resid.ScopedResourceName("clasploop")));	
	}

	public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		// Log.Debug(this.logGroup, "Resources loaded...");
		// await SlotGameType1Shared.Instance().ResourcesLoaded(loadingStage, resourceManager, this.params.jackpotEnable);

		for (let item of this.loadingSequence)
		{
			await item.Loaded?.(resourceManager);
		};
	}



	protected async PrepareVideos(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		//USE for Change the Video path for overwrite 
		if (Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay) {
			this.JackpotVideoResource = "multigame/slot/common/resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/" + Settings.Screens + "-screenResources";

			//if (this.JackpotVideoResource) {
			resourceManager.AddGlobal(new VideoResource2({
				resid: ResourceIdentifier.Global.Add("jp4"),
				logGroup: LogGroup.Global.Add("JP4Video"),
				src: Settings.ResourcesFolder + this.JackpotVideoResource + "/jp4",
				unloadOnEnd: true
			}));


			resourceManager.AddGlobal(new VideoResource2({
				resid: ResourceIdentifier.Global.Add("jp3"),
				logGroup: LogGroup.Global.Add("JP3Video"),
				src: Settings.ResourcesFolder + this.JackpotVideoResource + "/jp3",
				unloadOnEnd: true
			}));

			resourceManager.AddGlobal(new VideoResource2({
				resid: ResourceIdentifier.Global.Add("jp2"),
				logGroup: LogGroup.Global.Add("JP2Video"),
				src: Settings.ResourcesFolder + this.JackpotVideoResource + "/jp2",
				unloadOnEnd: true
			}));


			resourceManager.AddGlobal(new VideoResource2({
				resid: ResourceIdentifier.Global.Add("jp1"),
				logGroup: LogGroup.Global.Add("JP1Video"),
				src: Settings.ResourcesFolder + this.JackpotVideoResource + "/jp1",
				unloadOnEnd: true
			}));
		}
		else{
			throw `Spin And Hold Its Not implemented for PrepareVideos ${Settings.JackpotDisplayType}`;
		}
	}

	

	public async PrepareTransition(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{

		let pathTrack: string;
		let pathSprite: string;
		let pathVideo: string;
		if (Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay) {
			let pathTrack = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/tracks/" + this.jackpotName + Settings.audioFormat;
			let pathSprite = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/" + this.jackpotName + "_Transition";
			let pathVideo = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/Background_" + this.ScreenNumberConfiguration + "S";
			//Overwrite this video path because for this jackpots need different 
			if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep || Settings.JackpotDisplayType == JackpotDisplayType.DragonJackpot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotRappidFrames) {
				pathVideo = Settings.ResourcesFolder + "multigame/slot/" + this.gameName + "/resources/video/presentation_" + this.ScreenNumberConfiguration + "s";
				//pathTrack  = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/tracks/DiamondPot" + Settings.audioFormat;
			}

			resourceManager.AddGlobal(new SpriteResource(pathSprite, ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName), true, LogGroup.Global.Add("TitleTransition").Add(this.bonusName), true))
			this.audio.AddTrack(new Track(pathTrack, this.resid.ScopedResourceName("VoiceJackpotType")));

			if (Settings.PresentationType == Presentation.VideoGameSprite) {
				resourceManager.AddGlobal(new VideoResource2({
					resid: ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
					logGroup: LogGroup.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
					src: pathVideo,
					unloadOnHide: true
				}));
			}
			else if (Settings.PresentationType == Presentation.VideoCommonNoSprite) {
				pathVideo = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + this.jackpotName+ "/BackgroundVideoSprite_" + this.ScreenNumberConfiguration + "S";
				resourceManager.AddGlobal(new VideoResource2({
					resid: ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
					logGroup: LogGroup.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
					src: pathVideo,
					unloadOnHide: true
				}));
			}
			else if (Settings.PresentationType == Presentation.Image) {
				let pathImgTransition = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/BackgroundTransition_" + this.ScreenNumberConfiguration + "S.png";
				if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep) {
					pathImgTransition = `${this.params.gamepath}resources/BackgroundTransition_${this.ScreenNumberConfiguration}S.png`;
				}
				resourceManager.AddGlobal(new ImageResource(pathImgTransition,
					ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-BackgroundTransition-" + this.ScreenNumberConfiguration).Scope()));
				//debugger
			}
			else if (Settings.PresentationType == Presentation.VideoCommonClassic) {
				pathVideo = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/BackgroundCommonVideo_" + this.ScreenNumberConfiguration + "S";
				resourceManager.AddGlobal(new VideoResource2({
					resid: ResourceIdentifier.Global.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
					logGroup: LogGroup.Global.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
					src: pathVideo,
					unloadOnHide: true
				}));
			}
			else if (Settings.PresentationType == Presentation.VideoParticleTransitionMatterJS) {
				resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
				// resourceManager.AddGlobal(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/partitleTransitionBoundingBox.json`,
				// ResourceIdentifier.Global.Add(this.gameName + "-" +this.bonusName + "-partitleTransitionBoundingBox").Shared().CSSScope(),true));
			}
			else if (Settings.PresentationType == Presentation.VideoParticleTransitionFadeInFadeOut) {
				resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
				// resourceManager.AddGlobal(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/partitleTransitionBoundingBox.json`,
				// ResourceIdentifier.Global.Add(this.gameName + "-" +this.bonusName + "-partitleTransitionBoundingBox").Shared().CSSScope(),true));
			}
		}
		else {
			throw `Spin And Hold Its Not implemented for PrepareTransition ${Settings.JackpotDisplayType}`;
		}
	}

	
	protected EnableFadeOutVideo():boolean{
		return true;
	}

	// //LOAD FOR TRANSITION 
	public async TransitionLoaded(resourceManager: IReadOnlyResourceManager)
	{
		let transitionResources: ITransitionParams = null;
		if (Settings.PresentationType == Presentation.VideoGameSprite) {
			 transitionResources = {
				spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName)),
				videoResource: resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.gameName +"-"+this.bonusName+"-Transition-"+this.ScreenNumberConfiguration)),
				soundResource: this.audio.Track(this.resid.ScopedResourceName("VoiceJackpotType")),
				audio: this.audio,
				//basePath: this.params.commonpath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid,
				imgResource: null,
				nameResource : this.gameName +"-"+this.bonusName+"-Transition-"+this.ScreenNumberConfiguration,
				fadeOut : this.EnableFadeOutVideo(),
				particlesSprite : null,
				//boundingBox : null
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else if (Settings.PresentationType == Presentation.Image) {
			transitionResources = {
				spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName)),
				videoResource: null,
				soundResource: this.audio.Track(this.resid.ScopedResourceName("VoiceJackpotType")),
				audio: this.audio,
				//basePath: this.params.commonpath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid,
				imgResource: resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add(this.gameName  +"-"+this.bonusName+"-BackgroundTransition-" + this.ScreenNumberConfiguration)),
				nameResource : null,
				fadeOut : this.EnableFadeOutVideo(),	
				particlesSprite : null,
				//boundingBox : null	
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,	
			};
		}		
		else if (Settings.PresentationType == Presentation.VideoCommonNoSprite) {
			 transitionResources = {
				spriteResource: null,
				videoResource: resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.gameName +"-"+this.bonusName+"-Transition-"+this.ScreenNumberConfiguration)),
				soundResource: this.audio.Track(this.resid.ScopedResourceName("VoiceJackpotType")),
				audio: this.audio,
				//basePath: this.params.commonpath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid,
				imgResource: null,
				nameResource : this.gameName +"-"+this.bonusName+"-Transition-"+this.ScreenNumberConfiguration,
				fadeOut : this.EnableFadeOutVideo(), 
				particlesSprite : null,
				//boundingBox : null
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else if (Settings.PresentationType == Presentation.VideoCommonClassic) {
			transitionResources = {
				spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName)),
				videoResource: resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration)),
				soundResource: this.audio.Track(this.resid.ScopedResourceName("VoiceJackpotType")),
				audio: this.audio,
				//basePath: this.params.commonPath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				imgResource: null,
				nameResource: this.bonusName + "-Transition-" + this.ScreenNumberConfiguration,
				fadeOut: true,
				particlesSprite : null,
				//boundingBox : null
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else if (Settings.PresentationType == Presentation.VideoParticleTransitionMatterJS) {
			//let jsonBoundingBox = (resourceManager.Get<JSONResource>(this.resid.Add(`Symbol-PartitleTransitionBoundingBox`).Shared().CSSScope()).json) as IMyBoundingBox;
			//console.log(`ParticleBoundingBox-${this.gameName}:`,jsonBoundingBox.boundingbox)			
			transitionResources = {
				spriteResource:  resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName)),
				videoResource: null,
				soundResource: this.audio.Track(this.resid.ScopedResourceName("VoiceJackpotType")),
				audio: this.audio,
				//basePath: this.params.commonPath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				imgResource: null,
				nameResource: this.bonusName + "-Transition-" + this.ScreenNumberConfiguration,
				fadeOut: true,
				particlesSprite : resourceManager.Get<PixiSpriteResource>(this.resid.Add(`Partitle-Transition`).Shared()).sprite,
				boundingBox : null,
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else if (Settings.PresentationType == Presentation.VideoParticleTransitionFadeInFadeOut) {
			//let jsonBoundingBox = (resourceManager.Get<JSONResource>(this.resid.Add(`Symbol-PartitleTransitionBoundingBox`).Shared().CSSScope()).json) as IMyBoundingBox;
			//console.log(`ParticleBoundingBox-${this.gameName}:`,jsonBoundingBox.boundingbox)			
			transitionResources = {
				spriteResource:  resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName)),
				videoResource: null,
				soundResource: this.audio.Track(this.resid.ScopedResourceName("VoiceJackpotType")),
				audio: this.audio,
				//basePath: this.params.commonPath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				imgResource: null,
				nameResource: this.bonusName + "-Transition-" + this.ScreenNumberConfiguration,
				fadeOut: true,
				particlesSprite : resourceManager.Get<PixiSpriteResource>(this.resid.Add(`Partitle-Transition`).Shared()).sprite,
				boundingBox : null,
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else {
			throw `${Settings.PresentationType} its not implemented change your setting PresentationType`
		}
		
		// this.systemContext.SharedTransitionContext().AddTransition(transitionResources);

		// this.transitionView = this.transitionViewFactory.Create(transitionResources);
		// //this.transitionView.PrepareResources(resourceManager);

		// await this.transitionView.ResourcesLoaded(resourceManager);
		// this.view.appendChild(this.transitionView.View());
		// this.transitionView.onTransitionStart = () =>{
		// 	this.OnTransitionStarted();
		// }

		// this.transitionView.onTransitionEnd = () =>{
		// 	this.OnTransitionEnded();
		// }

		this.transitionView = await this.systemContext.SharedTransitionContext().AddTransition(transitionResources);		
		//this.transitionView.ResourcesLoaded(resourceManager);		
		this.transitionView.onTransitionEnd = () => {
			this.OnTransitionEnded()
		}
		this.transitionView.onTransitionStart = () => {
			this.OnTransitionStarted()
		}
		
	}
	
	//ADD THIS OVERWRITE FOR FIX VIDEO BACKGROUND FOR JP WIN SHOW 
	//ONLY 2Screen and 3 use video 
	protected async VideosLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

		
		//if(this.ScreenNumberConfiguration == 3)
		//{
			// make sure jackpot videos loop
			let jp4 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp4")).video;
			//jp4.video.loop = true;
			SetStyles(jp4.View(), { position: "absolute", top: Scale.Ypx(0), left: Scale.Xpx(0), zIndex: ZIndex.JPWinVideo.toString() });
			this.systemContext.SharedVideoContext().AddVideo(jp4);

			let jp3 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp3")).video;
			//jp3.video.loop = true;
			SetStyles(jp3.View(), { position: "absolute", top: Scale.Ypx(0), left: Scale.Xpx(0), zIndex: ZIndex.JPWinVideo.toString() });
			this.systemContext.SharedVideoContext().AddVideo(jp3);

			let jp2 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp2")).video;
			//jp2.video.loop = true;
			SetStyles(jp2.View(), { position: "absolute", top: Scale.Ypx(0), left: Scale.Xpx(0), zIndex: ZIndex.JPWinVideo.toString() });
			this.systemContext.SharedVideoContext().AddVideo(jp2);

			let jp1 = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("jp1")).video;
			//jp1.video.loop = true;
			SetStyles(jp1.View(), { position: "absolute", top: Scale.Ypx(0), left: Scale.Xpx(0), zIndex: ZIndex.JPWinVideo.toString() });
			this.systemContext.SharedVideoContext().AddVideo(jp1);

			
			// if(this.ScreenNumberConfiguration == 3)
			// {
			// let transitionVideo: MyVideo = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.gameName)).video;
			// SetStyles(transitionVideo.View(), { position: "absolute", top: Scale.Ypx(0), left: Scale.Xpx(0),zIndex:ZIndex.BonusTransition.toString() });
			// this.systemContext.SharedVideoContext().AddVideo(transitionVideo);
			// transitionVideo.AddOnPlayCallback(this.resid, () => this.OnTransitionStarted());
			// transitionVideo.AddOnEndedCallback(this.resid, () => this.OnTransitionEnded());
			// }
			// else
			// {
			// 	//DONT USE for 2SCreen Games
			// }
			
		//}
	}


	protected ButtonCanvasText(resourceManager: IReadOnlyResourceManager)
	{
		this.buttonStartCanvas = new MyCanvas(new Size(Scale.W(454), Scale.H(300)), {
			style: {
				left: Scale.Xpx(8),
				top: Scale.Ypx(12),
				position: "relative",
				zIndex: ""+ ZIndex.BonusWin
			}
		});

		this.SetTextCanvas(this.translator.t.freegameStart, this.buttonStartCanvas);

		this.buttonExitCanvas = new MyCanvas(new Size(Scale.W(454), Scale.H(300)), {
			style: {
				left: Scale.Xpx(8),
				top: Scale.Ypx(12),
				position: "relative",
				zIndex: ""+ ZIndex.BonusWin
			}
		});

		this.SetTextCanvas(this.translator.t.freegameExit, this.buttonStartCanvas);
	}

	public SetTextCanvas(text: string, canvas: MyCanvas)
	{
		canvas.context.clearRect(0, 0, canvas.size.Width,canvas.size.Height);

		let gradient = canvas.context.createLinearGradient( 
			canvas.size.Width / 2, 
			canvas.size.Height / 2 - this.fontHeight/2, 
			canvas.size.Width / 2, 
			canvas.size.Height /2 + this.fontHeight/2
		);

		gradient.addColorStop(0,    "#F2E416");
		gradient.addColorStop(0.25, "#F2BE22");
		gradient.addColorStop(0.50, "#C2760E");
		gradient.addColorStop(0.75, "#F2BE22");
		gradient.addColorStop(1,    "#F2E416");

		canvas.context.fillStyle = gradient;

		canvas.context.font = "bold " + this.fontHeight + "px " + this.resid.ScopedResourceName("bigwincount") ;
		canvas.context.textBaseline = "middle";
		canvas.context.textAlign="center";
		canvas.context.lineJoin="round"; //Experiment with "bevel" & "round" for the effect you want!
		canvas.context.miterLimit = 2;

		canvas.context.strokeStyle = "black";
		canvas.context.lineWidth = Scale.fh(22);
		canvas.context.strokeText(text, canvas.size.Width / 2, canvas.size.Height / 2);
		canvas.context.strokeText(text, canvas.size.Width / 2, canvas.size.Height / 2);
		canvas.context.fillText(text,   canvas.size.Width / 2, canvas.size.Height / 2);

		gradient = null;
		canvas = null;
	}

	protected async CreateAppBonusView() : Promise<void>  {		
		// this.bonusAppView = new BonusAppPixi(this.resid, this.systemContext);
		// this.bonusAppView.OnCreatedCallback = () => {
		// 	this.spinnableReels2.Create(this.bonusAppView.GetAppView());
		// };

		// this.view.appendChild(this.bonusAppView.GetView());
	}


	protected textureDialogBonus: PIXI.Texture<PIXI.Resource>;
	protected textureButtonBonus: PIXI.Texture<PIXI.Resource>;
	protected textureIntroBonus: PIXI.Texture<PIXI.Resource> [] = [];
	protected textureFinalBonus: PIXI.Texture<PIXI.Resource> [] = [];

	
	protected textureByLanguage : Record <keyof typeof translationMap , TextureDialogLanguage > = {
		romanian: {
			textureBonusIntro : null,
			textureBonusFinal : null,
		},
		spanish: {
			textureBonusIntro : null,
			textureBonusFinal : null,
		},
		english: {
			textureBonusIntro : null,
			textureBonusFinal : null,
		}
	}

	protected async SetContainers(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		// await this.ButtonCanvasText(resourceManager);
		// await this.PrepareIntroMessage(resourceManager);	
		// await this.PrepareFinalMessage(resourceManager);
		// await this.PrepareReelsContainer(resourceManager);

		// this.containers.set(SpinAndHoldContainer.IntroMessage, this.introMessageContainer);
		// this.containers.set(SpinAndHoldContainer.Reels, this.reelsContainer);
		// this.containers.set(SpinAndHoldContainer.FinalMessage, this.finalMessageContainer);
	}

	protected async LoadedResourcesBonusViewApp(resourceManager: IReadOnlyResourceManager){
		let dialogTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["dialog", "image"]));
        this.textureDialogBonus = PIXI.Texture.from(dialogTexturesDecoded.DecodedImage());


		let buttonTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["button", "image"]));
        this.textureButtonBonus = PIXI.Texture.from(buttonTexturesDecoded.DecodedImage());


		//create texture englis y rumano
		//intro
		let introEnglishTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["intro", "english"]));
        //introEnglishTextureBasePixi.scaleMode = PIXI.SCALE_MODES.NEAREST;
		const englishIntroTexture = PIXI.Texture.from(introEnglishTexturesDecoded.DecodedImage());
        this.textureIntroBonus.push(englishIntroTexture);
		this.textureByLanguage.english.textureBonusIntro = englishIntroTexture;


		//end
		let finalEnglishTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["end", "english"]));
		const englishFinalTexutre = PIXI.Texture.from(finalEnglishTexturesDecoded.DecodedImage());
        this.textureFinalBonus.push(englishFinalTexutre);
		this.textureByLanguage.english.textureBonusFinal = englishFinalTexutre;



		// create testure spanish		
		//intro
		let introSpanishTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["intro", "spanish"]));
		const spanishIntroTexutre = PIXI.Texture.from(introSpanishTexturesDecoded.DecodedImage());
        this.textureIntroBonus.push(spanishIntroTexutre);		
		this.textureByLanguage.spanish.textureBonusIntro = spanishIntroTexutre;
		//end
		let finalSpanishTexturesDecoded = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["end", "spanish"]));
		const spanishFinalTexutre = PIXI.Texture.from(finalSpanishTexturesDecoded.DecodedImage());
        this.textureFinalBonus.push(spanishFinalTexutre);
		this.textureByLanguage.spanish.textureBonusFinal = spanishFinalTexutre;
	}


	protected PrepareIntroMessage(resourceManager: IReadOnlyResourceManager): void {
		this.introMessageContainer = CreateElement("div", {
			classes: ["introMessageContainer"], 
			style:
			{
				position: "absolute",
				bottom: Scale.Ypx(0),
				left: Scale.Xpx(0),
				width: Scale.Wpx(1920),
				height: Scale.Hpx(1080),
				zIndex:ZIndex.BonusCofirmMessage.toString(),
			}
		});

		let messageContainer: HTMLElement = CreateElement("div", {
			classes: ["messageContainer"], parentToAppend: this.introMessageContainer,
			style:
			{
				width: Scale.Wpx(1920),
				height: Scale.Hpx(1080),
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				color: "yellow",
				//fontFamily: resourceManager.Get<FontResource>(this.resid.ScopedResourceName(["lines", "font"])).name,
			}
		});

		let dialog: HTMLElement = CreateElement("div", {
			classes: ["dialog"], parentToAppend: messageContainer,
			style:
			{
				position: "absolute",
				width: Scale.Wpx(1152),
				height: Scale.Hpx(648),
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["dialog", "image"])).CssBackground(),
				justifyContent: "center",
				alignContent: "center",
				zIndex: ZIndex.JPType.toString(),
			}
		});


		let buttonContainer: HTMLElement = CreateElement("div", {
			classes: ["buttonContainer"], parentToAppend: dialog,
			style:
			{
				position: "absolute",
				bottom: Scale.Ypx(-129),
				width: Scale.Wpx(1152),
				height: Scale.Hpx(300),
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			}
		})

		let button: HTMLElement = CreateElement("div", {
			classes: ["button"], parentToAppend: buttonContainer,
			style:
			{
				width: Scale.Wpx(600),
				height: Scale.Hpx(300),
				fontSize: Scale.fhpx(100),
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["button", "image"])).CssBackground(),
			}
		});


		let textIntroSpanish = CreateElement("div", {
			style:
			{
				width: Scale.Wpx(1052),
				height: Scale.Hpx(548),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["intro", "spanish"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				position:"absolute",
				top: Scale.Ypx(-24),
				left: Scale.Xpx(51),
			}
		});

		let textIntroEnglish = CreateElement("div", {
			style:
			{
				width: Scale.Wpx(1052),
				height: Scale.Hpx(548),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["intro", "english"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				position:"absolute",
				top: Scale.Ypx(-24),
				left: Scale.Xpx(51),
			}
		});

		dialog.appendChild(this.translator.Anchor(() => this.translator.t.BigFG(textIntroSpanish.outerHTML, textIntroEnglish.outerHTML)));
		
		this.SetTextCanvas(this.translator.t.freegameStart, this.buttonStartCanvas);
		button.appendChild(this.buttonStartCanvas.View());
	
		AddMouseDownListener(button, () => {
			if (this.stateMachine.State() == SpinAndHoldState.IntroMessage) {
				// Log.Debug(this.logGroup, "Intro message confirmed");
				this.stateMachine.ChangeState(SpinAndHoldState.WaitFirstSpin);
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + SpinAndHoldState[this.stateMachine.State()] + ", required state: " + SpinAndHoldState[SpinAndHoldState.IntroMessage]);
			}
		});
	}

	protected PrepareFinalMessage(resourceManager: IReadOnlyResourceManager): void
	{
		this.finalMessageContainer = CreateElement("div", {classes:["finalMessageContainer"], parentToAppend: this.view, 
			style:
			{
				position:"absolute",
				bottom: Scale.Ypx(0),
				left: Scale.Xpx(0),
				width: Scale.Wpx(1920),
				height: Scale.Hpx(1080),
				zIndex:ZIndex.BonusCofirmMessage.toString(),
			}
		});

		let messageContainer: HTMLElement = CreateElement("div", {classes:["messageContainer"], parentToAppend: this.finalMessageContainer,
			style:
			{
				width: Scale.Wpx(1920),
				height: Scale.Hpx(1080),
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
				color:"yellow",
				//fontFamily: resourceManager.Get<FontResource>(this.resid.ScopedResourceName(["lines", "font"])).name,

			}
		});

		let dialog: HTMLElement = CreateElement("div",{classes:["dialog"],parentToAppend:messageContainer, 
			style:
			{
				position:"absolute",
				width: Scale.Wpx(1152),
				height: Scale.Hpx(648),
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["dialog", "image"])).CssBackground(),
			}
		});

		let buttonContainer: HTMLElement = CreateElement("div", {classes:["buttonContainer"], parentToAppend:dialog, 
			style:
			{
				position:"absolute",
				bottom: Scale.Ypx(-129),
				width: Scale.Wpx(1152),
				height: Scale.Hpx(300),
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			}
		})
		
		let button: HTMLElement = CreateElement("div", {classes:["button"], parentToAppend:buttonContainer, 
			style:
			{
				width: Scale.Wpx(600),
				height: Scale.Hpx(300),
				fontSize: Scale.fhpx(100),
				display: "flex",
				justifyContent:"center",
				alignItems:"center",
				backgroundSize: "contain",
				backgroundPosition: "center",
				backgroundRepeat:"no-repeat",
				backgroundImage :resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["button", "image"])).CssBackground(),
			}
		});

		let freegameTextFinalSpanish = CreateElement("span", {
			style:
			{
				width: Scale.Wpx(1052),
				height: Scale.Hpx(548),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["end", "spanish"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				position: "absolute",
				top: Scale.Ypx(-24),
				left: Scale.Xpx(51),
			}
		});

		let freegameTextFinalEnglish = CreateElement("span", {
			style:
			{
				width: Scale.Wpx(1052),
				height: Scale.Hpx(548),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["end", "english"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				verticalAlign: "middle",
				position:"absolute",
				top: Scale.Ypx(-24),
				left: Scale.Xpx(51),
			}
		});

		dialog.appendChild(this.translator.Anchor(() =>this.translator.t.BigFG(freegameTextFinalSpanish.outerHTML,freegameTextFinalEnglish.outerHTML)));

		this.SetTextCanvas(this.translator.t.freegameExit, this.buttonExitCanvas);	
		button.appendChild(this.buttonExitCanvas.View());
	
		AddMouseDownListener(button, () => {
			if (this.stateMachine.State() == SpinAndHoldState.FinalMessage) {		
				this.Spin();
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + SpinAndHoldState[this.stateMachine.State()] + ", required state: " + SpinAndHoldState[SpinAndHoldState.IntroMessage]);
			}
		});
	}

	protected PrepareReelsContainer(resourceManager: IReadOnlyResourceManager):void
	{
		this.reelsContainer = CreateElement("div",{classes:["reelsContainer"], parentToAppend:this.view,
			style:{
				width: Scale.Wpx(1920),
				height: Scale.Wpx(1080),
				display : "flex",
				position : "absolute",
				bottom : "0px"
			}
		})
	}


	protected async BasePrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//resourceManager.Add(new HTMLResource(this.params.commonBonusResourcesBasePath + "HoldAndSpin.html", this.resid.ScopedResourceName("html")));
		//resourceManager.Add(new CSSResource(this.params.commonBonusResourcesBasePath + "HoldAndSpin.css", this.resid.ScopedResourceName("css"), this.resid.CSSScope()));

		await this.PrepareFonts(resourceManager);
		await this.BackgroundPrepare(resourceManager);

		//resourceManager.Add(new ImageResource(this.params.gamepath + "resources/dialog.png", this.resid.ScopedResourceName(["dialog", "image"])));

		resourceManager.Add(new DecodedImageResource(this.params.gamepath + "resources/dialog.png", this.resid.ScopedResourceName(["dialog", "image"])));
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.jpg", this.resid.ScopedResourceName(["background", "image"])));


		//resourceManager.Add(new ImageResource(this.params.gamepath + "resources/button.png", this.resid.ScopedResourceName(["button", "image"])));

		resourceManager.Add(new DecodedImageResource(this.params.gamepath + "resources/button.png", this.resid.ScopedResourceName(["button", "image"])));

		// //LOAD DIAMOND POT SPRITE		
		// resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-BONUS-END-TEXTS_ENGLISH.png", this.resid.ScopedResourceName(["end", "english"])));
		// resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-BONUS-INTRO-TEXT_ENGLISH.png", this.resid.ScopedResourceName(["intro", "english"])));

		// resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-IBONUS-END-TEXTS_SPANISH.png", this.resid.ScopedResourceName(["end", "spanish"])));
		// resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-IBONUS-NTRO-TEXTS_SPANISH.png", this.resid.ScopedResourceName(["intro", "spanish"])));


		//LOAD DIAMOND POT SPRITE		
		resourceManager.Add(new DecodedImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-BONUS-END-TEXTS_ENGLISH.png", this.resid.ScopedResourceName(["end", "english"])));
		resourceManager.Add(new DecodedImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-BONUS-INTRO-TEXT_ENGLISH.png", this.resid.ScopedResourceName(["intro", "english"])));

		resourceManager.Add(new DecodedImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-IBONUS-END-TEXTS_SPANISH.png", this.resid.ScopedResourceName(["end", "spanish"])));
		resourceManager.Add(new DecodedImageResource(this.params.commonBonusResourcesBasePath + "resources/ContainerText/STICKY-IBONUS-NTRO-TEXTS_SPANISH.png", this.resid.ScopedResourceName(["intro", "spanish"])));

	}

	protected BackgroundPrepare(resourceManager: IWriteOnlyResourceManager) {
		//Yo
		resourceManager.Add(new ImageResource(this.params.gameBonusResourcesBasePath + "background"+this.ScreenNumberConfiguration+"S/" +"background.png", this.resid.ScopedResourceName(["background", "image"])));
		//Yo
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.2.jpg", this.resid.ScopedResourceName(["background.2", "image"])));
		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "background.3.jpg", this.resid.ScopedResourceName(["background.3", "image"])));
	}

	protected PrepareFonts(resourceManager: IWriteOnlyResourceManager): void {

		resourceManager.Add(new FontResource(this.params.commonBonusResourcesBasePath + "resources/newzone.ttf", this.resid.ScopedResourceName("bigwincount")));
		//resourceManager.Add(new FontResource(this.params.gameResourcesBasePath + "huggable.ttf", "." + this.resid.ScopedResourceName(["lines", "font"])));
	}

	protected gameBackground: string = null;
	protected async BaseLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		let gameBackground = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", "image"]));
        this.gameBackground = gameBackground.CssBackground();
		SetStyles(this.backgroundSpinHoldGame, {
			backgroundImage: this.gameBackground,
			backgroundSize: "100%",
		});
	}

	//History view
	protected async PrepareHistory(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		//resourceManager.Add(new CSSResource(Settings.ResourcesFolder + "multigame/slot/common/resources/playLines.css", this.resid.ScopedResourceName("playLines"), this.resid.Add("History").CSSScope()));
	}

	//protected historySpinableReels = null;
	protected historySymbolImg: ImageResource = null;
	protected async LoadedHistory(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		this.historySymbolImg = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["plusone", "image"]));

		// this.historySpinableReels = new S2_SpinnableReels2(
		// 	// TODO window symbol size must come as config from backend
		// 	{ reelConfig: this.config.ReelSet, windowSymbolsSize: new Size(5, 3)}, 
		// 	{ windowRect: this.params.windowRectangle }
		// );

		//this.historySpinableReels = new SpinnableReels(new Size(5, 4), new PixelRect(0, 0, 900, 640));
		// SetStyles(this.historySpinableReels.GetView(),
		// 	{
		// 		position: "static"
		// 	})
	}


	/**
	 *	BIG WIN
	 */
	protected async BigWinPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {
	}

	protected async BigWinLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

		// quit dont need fountain
		let fountainAnimation = SlotGameType1Shared.Instance().smallFountainAnimation;
		fountainAnimation.AddOnStartCallback(this.resid, () => this.audio.PlayLoop(this.parentresid.ScopedResourceName("fountain")));
		fountainAnimation.AddOnStopCallback(this.resid, () => this.audio.Stop(this.parentresid.ScopedResourceName("fountain")));
		fountainAnimation = null;

		let smallfountainAnimation = SlotGameType1Shared.Instance().mediumFountainAnimation;
		smallfountainAnimation.AddOnStartCallback(this.resid, () => this.audio.PlayLoop(this.parentresid.ScopedResourceName("fountain")));
		smallfountainAnimation.AddOnStopCallback(this.resid, () => this.audio.Stop(this.parentresid.ScopedResourceName("fountain")));
		smallfountainAnimation = null;

		let bigfountainAnimation = SlotGameType1Shared.Instance().bigFountainAnimation;
		bigfountainAnimation.AddOnStartCallback(this.resid, () => this.audio.PlayLoop(this.parentresid.ScopedResourceName("fountain")));
		bigfountainAnimation.AddOnStopCallback(this.resid, () => this.audio.Stop(this.parentresid.ScopedResourceName("fountain")));
		bigfountainAnimation = null;

	}

	/**
	 *	FEATURES
	 *  TODO check what features are actually enabled in freegames!
	 */
	protected async FeaturesPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "resources/coin.png", this.resid.ScopedResourceName(["plusone", "image"])));
		
		{
			let params: ScatterRandomAwardCreateParams = 
			{
				logGroup: this.logGroup,
				resid: this.resid,
				// reelSet: this.config.ReelSet.map(rs => rs.Symbols),
				availableSymbols: this.params.symbols,
			};

			const configs = FilterFeatures(this.config.MultiFeatureConfiguration, (f): f is ScatterRandomAwardConfiguration => f.FeatureType == "ScatterRandomAward");
			this.scatterRandomAwardFeature = new ScatterRandomAwardPIXI(params, configs, this.params.color);
			await this.scatterRandomAwardFeature.PrepareResources(resourceManager);
		}

		{
			// let params: HoldingFeatureParamsPIXI = 
			// {
			// 	logGroup: this.logGroup,
			// 	resid: this.resid,
			// 	spinnableReels: this.spinnableReels2,
			// 	gameResourcesBasePath: this.params.gameBonusResourcesBasePath,
			// 	reelsCoverAnotherScreen : false

			// };

			// this.holdingFeature = new HoldingFeaturePIXIApp(params);
			// await this.holdingFeature.PrepareResources(resourceManager);
			// params = null;
			await this.HoldingFeaturePrepare(resourceManager)
		}
	}

	protected async HoldingFeaturePrepare(resourceManager: IWriteOnlyResourceManager){
		let params: HoldingFeatureParams = 
		{
			logGroup: this.logGroup,
			resid: this.resid,
			spinnableReels: this.spinnableReels2,
			gameResourcesBasePath: this.params.gameBonusResourcesBasePath,
			reelsCoverAnotherScreen : false

		};

		this.holdingFeature = new HoldingFeature(params);
		await this.holdingFeature.PrepareResources(resourceManager);
		params = null;
	}

	protected async FeaturesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		{
			await this.scatterRandomAwardFeature.ResourcesLoaded(resourceManager);
		}

		{
			await this.holdingFeature.ResourcesLodaded(resourceManager, this.scatterRandomAwardFeature.GetAwardOptions());
			this.view.appendChild(this.holdingFeature.View());
			this.holdingFeature.View().style.display = "none";
		}
	}

	protected async CometsPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		// TODO share comets with pickbonus or use separate comets?
		//resourceManager.AddGlobal(new SpriteResource(this.params.commonBonusResourcesBasePath + "resources/cometShort", ResourceIdentifier.Global.Add("SpinAndHold").Add("Commet"), true, LogGroup.Global.Add("SpinAndHold").Add("Commet"), true))
		this.commetView = this.commetFactory.CreateComet(this.audio , this.resid, this.params.FpsFactor);
		await this.commetView.PrepareResources(resourceManager);
	}

	//
	protected skipMessageHide : ITimeout = null;	
	protected skipMessageCommets : HTMLElement = null;	
	protected async SpriteCometsLoaded(resourceManager: IReadOnlyResourceManager){
		//this.comet = new Comet(new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("SpinAndHold").Add("Commet")).sprite.Copy(), canvasSize: null, drawFirstFrame: true, sizing: CanvasSpriteSizing.Stretch}));
        //this.comet.OnCompleteCallback = this.OnCometEnd.bind(this);

		await this.commetView.ResourcesLoaded(resourceManager);
		this.commetView.OnCompleteCallback = this.OnCometEnd.bind(this);
	}

	protected async CometsLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		await this.SpriteCometsLoaded(resourceManager);
		SetStyles(this.commetView.View(), {
			position: "absolute",
			top: Scale.Ypx(0),
			left: Scale.Xpx(0),
			zIndex: ZIndex.Jp1Comet.toString()
		});

		this.view.appendChild(this.commetView.View());

		this.skipMessageCommets = CreateElement("div",{
			parentToAppend : this.view,
			classes:["skipMessageCommets"],
			style:{
				width: "100%",
				height: Scale.Hpx(1080),
				color : "white",
				fontSize : Scale.fhpx(90),
				fontFamily: "NotoSansDisplay-ExtraBold",
				display : "none",
				position : "absolute",
				justifyContent : "center",
				textAlign:"center",
				zIndex : ZIndex.Jp1Comet.toString(),
				lineHeight : "normal",
				alignItems : "center",
				bottom : "0px",
			}
		});

		let skipMessageBackgroundCommets = CreateElement("div",{
			parentToAppend : this.skipMessageCommets,
			classes:["skipMessageBackgroundCommets"],
			style:{
				width: "30%",
				height: "20%",
				backgroundColor : "rgba(0,0,0,0.8)",
				fontSize : Scale.fhpx(30),
				fontFamily: "NotoSansDisplay-ExtraBold",
				display : "flex",
				position : "relative",
				justifyContent : "center",
				textAlign:"center",				
				lineHeight : "normal",
				alignItems : "center",
				borderRadius : Scale.fhpx(50),	
				bottom : Scale.Ypx(-265),
			}
		});

		//this.skipMessageCommets.innerHTML = "Skip Presentation <br> Press Start";

		skipMessageBackgroundCommets.appendChild(this.translator.Anchor(() => this.translator.t.skipMessageCommets));
		

		this.skipMessageHide = this.systemContext.TimingContext().CreateTimeout("skipMessageHideShowTime", 1500, () => {
			TweenLite.to(this.skipMessageCommets, 1, {display: "none" });
		});

		//was created and used dosent need save it
		skipMessageBackgroundCommets = null;
	}

	

	/**
	 *	REELS
	 */
	public async PrepareBackgroundReel(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		this.spinnableReelsParams.backgroundImage = new DecodedImageResource(this.params.gameBonusResourcesBasePath + "reel.png", this.resid.ScopedResourceName(["reelFregame", "image"]));
		resourceManager.Add(this.spinnableReelsParams.backgroundImage);

		// this.spinnableReelsParams.maskbackgroundImage = new ImageResource(this.params.gameBonusResourcesBasePath + "resources/reelMask.png", this.resid.ScopedResourceName(["reelMask", "image"]));
		// resourceManager.Add(this.spinnableReelsParams.maskbackgroundImage);

		// prepare backgrounds
		//need fit GetReels
		let differentBackgrounds: string[] = this.config.SymbolSpanSizes
			// generate name for each reel
			.map(spanSize => spanSize.ColSpan + "x" + spanSize.RowSpan)
			// filter only unique
			.filter(Filter.UniqueItem);

		differentBackgrounds.forEach(reelsize => {
			resourceManager.Add(new DecodedImageResource(this.params.gameBonusResourcesBasePath + "reel_" + reelsize + ".png", this.resid.ScopedResourceName(["reelbackground", reelsize])));
			resourceManager.Add(new DecodedImageResource(this.params.gameBonusResourcesBasePath + "reelmask_" + reelsize + ".png", this.resid.ScopedResourceName(["reelbackgroundMask", reelsize])));
		});
	}

	protected async DemoLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		if (this.params.slotGameMeta.Demo == true) {

			this.view.appendChild(this.demoMessage);
		}
	}

	protected ConstructReelParams (constructReelsParams: ConstructReelsParams){
		this.spinnableReels2 = new S2_SpinnableReelsBigCanvas2(
			this.resid,
			{
				reelConfig: constructReelsParams.ReelSet,
				playWindow: constructReelsParams.PlayWindow,
			},
			{
				windowRect: constructReelsParams.WindowRect,
				leftBorderWidth: this.params.spinnableReelsParams.leftBorderWidth,
				rightBorderWidth: this.params.spinnableReelsParams.rightBorderWidth,
				topBorderWidth: this.params.spinnableReelsParams.topBorderWidth,
				bottomBorderWidth: this.params.spinnableReelsParams.bottomBorderWidth,
				backgroundImage : this.params.spinnableReelsParams.backgroundImage,
				
				pixiSpritesByName : this.params.pixiSpritesByName,

			},
			this.systemContext,
			false
		);
	}
	protected reelSpinAnimations:S2_ReelSpinAnimation[] = [];

	protected ConstructReels2(constructReelsParams: ConstructReelsParams)
	{
		this.spinAnimation2?.Destroy();
		this.spinnableReels2?.Destroy();

		{

			// update center reel so it is visible 1 symbol above, in the 2. screen
			let centerReel: S2_IReelConfig = constructReelsParams.ReelSet.find(r => r.Name.toLowerCase() == "center");
			if (centerReel)
			{
				if (centerReel.Height != 1) throw "Center reel expected to be 1 symbol high";
				if (centerReel.Row != 0) throw "Center reel expected to start in row 0";
				if (centerReel.RowSpan != constructReelsParams.PlayWindow.Height) throw `Center reel expected have rowspan ${constructReelsParams.PlayWindow.Height}`;

				//centerReel.ExtraSymbolsAbove = 1;
			}

			this.ConstructReelParams(constructReelsParams);

			// this.reelSpinAnimations: S2_ReelSpinAnimation[] = [];



			let animationColumns: number[] = this.spinnableReels2.GetAnimationColumns();
			
			animationColumns.forEach((animationColumn, animationColumnIndex) => {

				


				let symbolHeight = this.spinnableReels2.GetSymbolSizePixels2(animationColumnIndex, 0).Height;

				// // speed correction
				// const someReel = this.config.ReelSet.filter(r => r.Col == animationColumn)[0];
				// let speedCorrection = someReel.Height / someReel.RowSpan;

				// // old speed correction
				// let oldSpeedCorrection = this.spinnableReels2.GetOriginalSymbolSize().height / this.spinnableReels2.GetWindowSize().height;

				// console.log(`${this.logGroup.Name} column ${animationColumn}(${animationColumnIndex}) new speed correction ${speedCorrection * 0.125}   height ${someReel.Height} span ${someReel.RowSpan}`);
				// console.log(`${this.logGroup.Name} column ${animationColumn}(${animationColumnIndex}) old speed correction ${oldSpeedCorrection * 0.65} symbol ${this.spinnableReels2.GetOriginalSymbolSize().height} window ${this.spinnableReels2.GetWindowSize().height}`);


				let params:S2_ReelSpinAnimParams = {
					logGroup: this.logGroup,
					columnIndex: animationColumnIndex,
					symbolHeightInPixels: symbolHeight,
					overshootHeightInSymbols: 0.125 * symbolHeight,
					deccelerationHeightInSymbols: this.spinnableReels2.GetMaxReelHeightInSymbols() +1,
					speedCorrection: this.params.reelAnimationParams.SpeedCorrection,
					delay: this.params.reelAnimationParams.Delay
				};
		
				let reelSpinAnimation = new S2_ReelSpinAnimation(params);
				this.reelSpinAnimations.push(reelSpinAnimation);


				reelSpinAnimation.AddOnUpdateCallback(this.ReelColumnUpdate.bind(this));


				reelSpinAnimation.AddOnStartCallback((anim) => {
					try {
						let reelsToAnimate: S2_ISpinnableReelPIXI[] = this.spinnableReels2.GetReelsInAnimationColumn(anim.ColumnIndex);

						for (let r = 0; r < reelsToAnimate.length; r++) {
							let reelToAnimate = reelsToAnimate[r];
							let reelMapper = this.reelSetMapper2.GetReelMapper(reelToAnimate.Config.Index);
							reelMapper.Start();

							reelToAnimate.ReelElement.mask = reelToAnimate.SpinMaskElement;
							//reelToAnimate.SpinMaskElement.style.overflow = "hidden";
							reelToAnimate.TopHiddenSymbols.visible = true;
							reelToAnimate.BottomHiddenSymbols.visible = true;
							reelMapper = null;
							reelToAnimate = null;
							//reelToAnimate.ReelWindowElement.style.overflow = "hidden";
						}
					} catch (error) {
						Log.Error(this.logGroup, "Error GetReelsInAnimationColumn", error);
					}
				});

				reelSpinAnimation.AddOnDeccelerationCallbak((anim, params) => {
					try {
						let reelsToAnimate: S2_ISpinnableReelPIXI[] = this.spinnableReels2.GetReelsInAnimationColumn(anim.ColumnIndex);

						for (let r = 0; r < reelsToAnimate.length; r++) {
							let reelToAnimate = reelsToAnimate[r];
							let reelMapper = this.reelSetMapper2.GetReelMapper(reelToAnimate.Config.Index);
							let distanceInSymbols = params.totalDistanceInSymbols;
							reelMapper.Slice(distanceInSymbols);
							distanceInSymbols = null;
							reelMapper = null;
							reelToAnimate = null;

						}
					} catch (error) {
						Log.Error(this.logGroup, "Error GetReelsInAnimationColumn", error);
					}
                });
                
                reelSpinAnimation.AddOnNearCompleteCallback((anim) => {
					try {
						this.OnReelStopped();
						let reelsToAnimate: S2_ISpinnableReelPIXI[] = this.spinnableReels2.GetReelsInAnimationColumn(anim.ColumnIndex);

						for (let r = 0; r < reelsToAnimate.length; r++) {
							let reelToAnimate = reelsToAnimate[r];

							reelToAnimate.ReelElement.mask = reelToAnimate.SpinMaskElement;
							reelToAnimate = null;
							//reelToAnimate.SpinMaskElement.transform.overflow = "";
						}

						//does this column contain any reel Spinning?
						let anyReelSpinning = !this.session.HoldReels || reelsToAnimate.filter(r => !this.session.HoldReels[r.Config.Index]).length > 0;
						if (anyReelSpinning) {
							this.audio.Play(this.parentresid.ScopedResourceName("reelstop"));
						}
						//does this column contain reel with big symbol?
						let columnContainsBigReel = reelsToAnimate.filter(r => r.Config.ColSpan > 1).length > 0;
						if (columnContainsBigReel) {
							this.audio.Play(this.resid.ScopedResourceName("bigreelSpinStop"));
						}
						reelsToAnimate = null;
					} catch (error) {
						Log.Error(this.logGroup, "Error GetReelsInAnimationColumn", error);
					}
                });

				reelSpinAnimation.AddOnCompleteCallback((anim) => {
					try {
						let reelsToAnimate: S2_ISpinnableReelPIXI[] = this.spinnableReels2.GetReelsInAnimationColumn(anim.ColumnIndex);

						for (let r = 0; r < reelsToAnimate.length; r++) {
							let reelToAnimate = reelsToAnimate[r];

							reelToAnimate.ReelElement.mask = reelToAnimate.SpinMaskElement;
							//reelToAnimate.SpinMaskElement.style.overflow = "";
							reelToAnimate.TopHiddenSymbols.visible = false;
							reelToAnimate.BottomHiddenSymbols.visible = false;
							//reelToAnimate.ReelWindowElement.style.overflow = "";
							reelToAnimate = null;
						}
						reelsToAnimate = null;
					} catch (error) {
						Log.Error(this.logGroup, "Error GetReelsInAnimationColumn", error);
					}
				})
			});

			this.spinAnimation2 = new S2_SpinAnimation(this.logGroup, constructReelsParams.ReelSet, this.reelSpinAnimations);
			this.spinAnimation2.AddOnCompleteCallback(() => {
				this.SpinComplete();
				this.audio.Stop(this.parentresid.ScopedResourceName("anticipation"));
				this.stateMachine.ChangeState(SpinAndHoldState.Features);
			});

			// if (Settings.touchToStop == true) {
			// 	AddMouseDownListener(this.gameViewApp.view, () => {
			// 		this.spinAnimation2.RequestStop();
			// 	});
			// }
		}


		this.reelSetMapper2 = new S2_ReelSetMapper(constructReelsParams.PlayWindow, this.logGroup);
		constructReelsParams.ReelSet.forEach((reelConfig, reelIndex) => {
			let m: S2_ReelMapper = new S2_ReelMapper(reelIndex, this.logGroup, reelConfig.Height, this.spinnableReels2.GetReelDisplayGeometry(reelIndex));
			
			// TODO add start position?
			// TODO add extended symbols?
			m.SetReel(reelConfig.Symbols, reelConfig.StartPosition || 0);
			this.reelSetMapper2.AddReelMapper(m);

		});

		this.currentSymbols = this.reelSetMapper2.GetSymbols2();
	}


	protected reelBackgroundMap: Map<string, DecodedImageResource> = new Map<string, DecodedImageResource>();
	protected reelBackgroundMaskMap: Map<string, DecodedImageResource> = new Map<string, DecodedImageResource>();
	protected async ReelsLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		await this.spinnableReels2.LoadedCanvasPIXI();

		//this.reelsContainer.appendChild(this.spinnableReels2.GetView());
		
		this.spinnableReels2.OnCreatedCallback = () => {
			this.ReelBackgroundLoaded();
			this.redrawPixiReels();
		};

		let reels = this.spinnableReels2.GetReelConfig();
		for (let reel of reels)
		{
			let backgroundSize = reel.ColSpan + "x" + reel.RowSpan;
			let imgResource: DecodedImageResource = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["reelbackground", backgroundSize]));
			this.reelBackgroundMap.set(backgroundSize, imgResource);

			let imgResourceMask: DecodedImageResource = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["reelbackgroundMask", backgroundSize]));
			this.reelBackgroundMaskMap.set(backgroundSize, imgResourceMask);
		}
	}


	protected ReelBackgroundLoaded() {		
		let reels = this.spinnableReels2.GetReels();

		
		
		for (let reel of reels)
		{
			let backgroundSize = reel.Config.ColSpan + "x" + reel.Config.RowSpan;	
			
			//BackgroundReel DecodeImage
			let imgResource: DecodedImageResource = this.reelBackgroundMap.get(backgroundSize);
			let backgroundReelTexture = PIXI.Texture.from(imgResource.DecodedImage());

			let scaleWidth = reel.BackgroundRect_pixels.width / backgroundReelTexture.width;
			let scaleHeight =  reel.BackgroundRect_pixels.height / backgroundReelTexture.height
			let scale = Math.min(scaleWidth, scaleHeight);
			backgroundReelTexture.baseTexture.width = backgroundReelTexture.width * scale;
			backgroundReelTexture.baseTexture.height = backgroundReelTexture.height * scale;

			
			reel.WindowBackgroundElement.texture = backgroundReelTexture;

			//backgroond reel Mask DecodeImage
			let imgResourceMask: DecodedImageResource = this.reelBackgroundMaskMap.get(backgroundSize);
			let backgroundReelMaskTexture = PIXI.Texture.from(imgResourceMask.DecodedImage());

			let scaleWidthMask = reel.BackgroundRect_pixels.width / backgroundReelMaskTexture.width;
			let scaleHeightMask =  reel.BackgroundRect_pixels.height / backgroundReelMaskTexture.height
			let scaleMask = Math.min(scaleWidthMask, scaleHeightMask);
			backgroundReelMaskTexture.baseTexture.width = backgroundReelMaskTexture.width * scaleMask;
			backgroundReelMaskTexture.baseTexture.height = backgroundReelMaskTexture.height * scaleMask;

			reel.SpinMaskElement.texture = backgroundReelMaskTexture;	
			
			


			// //old way load pixi background Texture
			// let textureBackgroundReel = PIXI.Texture.from(this.params.gameBonusResourcesBasePath + "reel_" + backgroundSize + ".png");
			// reel.WindowBackgroundElement.texture = textureBackgroundReel;		

			// let textureMaskReel = PIXI.Texture.from(this.params.gameBonusResourcesBasePath + "reelmask_" + backgroundSize + ".png");
			// reel.SpinMaskElement.texture = textureMaskReel;		
			
			imgResource = null;
			backgroundReelTexture = null;

			imgResourceMask = null;
			backgroundReelMaskTexture = null;
		};
	}

	protected ReelColumnUpdate(params: Readonly<S2_ReelSpinAnimationUpdateParams>): void {
		try {
			let reelsToAnimate: S2_ISpinnableReelPIXI[] = this.spinnableReels2.GetReelsInAnimationColumn(params.reelSpinAnimation.ColumnIndex);

			for (let r = 0; r < (reelsToAnimate?.length ?? 0); r++) {
				let reelToAnimate = reelsToAnimate[r];

				// Don't animate when holding
				if (this.session.HoldReels &&
					this.session.HoldReels[reelToAnimate.Config.Index] >= 0
				) {
					continue;
				}

				if (reelToAnimate?.ReelElement?.transform)
				{
					reelToAnimate.ReelElement.transform.position.y = params.modSymbolDistance;
				}

				let reelMapper = this.reelSetMapper2.GetReelMapper(reelToAnimate.Config.Index);
				reelMapper.Update(params.symbolDistance);

				if (reelMapper.DidSymbolsChange()) {
					this.currentSymbols[reelToAnimate.Config.Index] = reelMapper.GetSymbols2();

					for (let rowIndex: number = 0; rowIndex < reelToAnimate.ReelDisplayGeometry.symbolsTotal; rowIndex++) {
						this.DrawSymbol(reelToAnimate.Config.Index, rowIndex);
					}
				}
			}
		} catch (error) {
			Log.Error(this.logGroup, "Error GetReelsInAnimationColumn", error);
		}
	}

	protected currentSymbols: ReelSymbolsToDisplay[][] = [];
	public DrawSymbol(reelIndex: number, rowIndex: number): void {
		try {
			let canvasPIXI = this.spinnableReels2.pixiCanvas?.[reelIndex]?.[rowIndex];
			if (!canvasPIXI)
			{
				// no canvas to use
				return;
			}


			let symbolToDisplay: ReelSymbolsToDisplay = this.currentSymbols[reelIndex][rowIndex];
			let symbol: SlotSymbol = this.params.symbols[symbolToDisplay.symbolIndex];

			if (symbol.ID == this.requiredSymbol) {
				canvasPIXI.texture = this.params.pixiSpritesByName.get("Symbol_" + symbol.ID)[0];
				this.scatterRandomAwardFeature?.DrawPIXI(reelIndex, symbolToDisplay.reelPositionIndex, rowIndex, symbol, canvasPIXI as PIXI.AnimatedSprite);
			}
			else {
				canvasPIXI.texture = this.params.pixiSpritesByName.get("Symbol_" + symbol.ID)[0];
				this.scatterRandomAwardFeature?.DrawPIXI(reelIndex, symbolToDisplay.reelPositionIndex, rowIndex, symbol, canvasPIXI as PIXI.AnimatedSprite);
			}
			//this.scatterRandomAwardFeature?.DrawPIXI(reelIndex, symbolToDisplay.reelPositionIndex, rowIndex, symbol, canvasPIXI);
		} catch (error) {
			//Log.Error(this.logGroup, "Error drawing symbol", error);
		}
	}

	public Confirm(): void {
		if (this.stateMachine.State() == SpinAndHoldState.IntroMessage) {
			// Log.Debug(this.logGroup, "Intro message confirmed");
			this.Show();
			this.stateMachine.ChangeState(SpinAndHoldState.WaitFirstSpin);
		}
		else if (this.stateMachine.State() == SpinAndHoldState.FinalMessage) {
			// Log.Debug(this.logGroup, "Final message confirmed");
			this.ShowVideoTransition();					
		}
		else {
			Log.Error(this.logGroup, "Can't confirm message, current state: " + SpinAndHoldState[this.stateMachine.State()]);
		}
	}
	public Spin(): void {

		// Log.Debug(this.logGroup, "Spin");

		switch (this.stateMachine.State()) {
			//case SpinAndHoldState.Running:

			// when in idle state, spin starts new spin
			case SpinAndHoldState.SpinIdle:
			case SpinAndHoldState.WaitFirstSpin:

				// make sure to clear timer, to prevent double spin??
				if (this.session.RunsRemaining > 0) {

					// Log.Debug(this.logGroup, "Spin: Requesting next spin");

					if (this.autoSpinTimer != null) clearTimeout(this.autoSpinTimer);
					this.spinInterrupted = false;

					this.spinAnimation2.Start();
					//debugger;

					// TODO
					// protocol.Send("BonusNextRun", null);
					this.stateMachine.ChangeState(SpinAndHoldState.Spin);
				}
				break;
			case SpinAndHoldState.FinalMessage:
			case SpinAndHoldState.IntroMessage:
				if (this.stateMachine.TimeSinceLastStateChange() > 500) {
					// Log.Debug(this.logGroup, "Spin: Confirming message");
					this.Confirm();
				}
				break;

			case SpinAndHoldState.Spin:
				// Log.Debug(this.logGroup, "Spin: Request spin stop");
				this.spinAnimation2.RequestStop(-1);
				break;

			case SpinAndHoldState.Features:
				// Log.Debug(this.logGroup, "Spin: Request features stop");
				this.RequestFeatureStop();
				break;

			case SpinAndHoldState.CometCollect:
				// only skip if enabled in settings
				if (Settings.skipCommet == true) {

					//console.log(`Skipping commet ${this.currentScatterCometIndex} of ${this.scatterPositions.length}`);

					if (this.currentScatterCometIndex != -1 &&
						this.currentScatterCometIndex < this.scatterPositions.length &&
						this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.AwardOption.AwardType == AwardType.BetMultiplier &&
						this.stateMachine.TimeSinceLastStateChange() > 2000
					)
					{
						this.skipMessageCommets.style.display = "flex";

						this.skipMessageHide.Start();
						if (this.isShowed == false) {
							this.OnCometEnd();
						}
						this.RequestStopsCommetShowWin();
						this.NextComet();
					}
				}
				break;


			// When in win state, spin interrupts the count
			case SpinAndHoldState.Win:
				// Log.Debug(this.logGroup, "Spin: Request win stop");
				this.spinInterrupted = true;
				//this.winLinesAnimation.RequestStop();
				break;

			default:
				// Log.Debug(this.logGroup, "Spin: Nothing to do in current state: " + this.stateMachine.StateName);
				break;
		}
	}

	public AutoSpin(): void {
        if (this.params.bonusAutoplay && !this.isLocked)
        {
            // Log.Debug(this.logGroup, "Autospin");
            this.Spin();
        }
        else
        {
            // autospin disabled
        }
	}

	// TODO change, remove, improve
	public Reset(): void {
		this.lastSpinResult = null;
	}

	private SpinComplete(): void {
	}

	protected RedrawCanvasButton()
	{
		this.SetTextCanvas(this.translator.t.freegameStart, this.buttonStartCanvas);
		this.SetTextCanvas(this.translator.t.freegameExit,  this.buttonExitCanvas);
	}

	protected HideHoldingReels() {
		try {
			this.spinnableReels2.GetReels().forEach(r => {

				if (this.session.HoldReels[r.Config.Index] >= 0) {
					//SetStyles(r.ReelElement, {display: "none"});
					r.ReelElement.visible = false;
				}
				else {
					//SetStyles(r.ReelElement, {display: ""});
					r.ReelElement.visible = true;
				}
			});
		} catch (error) {
			Log.Error(this.logGroup, "Error HideHoldingReels", error);
		}
	}


	public Start(): void {

		// Log.Debug(this.logGroup, "Bonus started");

		//fix
		//this.RedrawCanvasButton();
		//this.basegameWinCents = basegameWinCents;

		this.lastSpinResult = null;
		this.session.Reset();
		this.session.RunsPlayed = 0;
		this.session.RunsStarted = this.simpleConfigSpinAndHold.SpinsStarted;
		this.session.RunsRemaining = this.simpleConfigSpinAndHold.SpinsRemaining;

		let scatterData = this.simpleConfigSpinAndHold.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as unknown  as ScatterRandomAwardResults;

		this.session.ScattersDisplayed = scatterData &&
		scatterData.ScattersTotal || 0;

		this.session.HoldReels = this.simpleConfigSpinAndHold.HoldReels;

		// hide holding reels on start, because they might show different symbols
		// and if HoldingFeature is covering symbol, the symbol might peek out
		this.HideHoldingReels();
		
		//this.stateMachine.ChangeState(SpinAndHoldState.IntroMessage);
		this.stateMachine.ChangeState(SpinAndHoldState.IntroTransition);

		//this.stateMachine.ChangeState(SpinAndHoldState.WaitFirstSpin);

		// Log.Debug(this.logGroup, "Bonus started");

		//this.Show();

		//this.PanelRequired(false);

		this.audio.Stop(this.resid.ScopedResourceName("background"));
		this.audio.PlayLoop(this.resid.ScopedResourceName("background"));

		// TODO use different message for start instead of SPIN
		this.screenProtocol?.Send(new SpinAndHoldMessages.SpinMessage(this.session), this.screenProtocolScope);
		this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.simpleConfigSpinAndHold.WinSinceGameStart.TotalWin.InCents), service.moneyFormatter.FormatCurrency(this.simpleConfigSpinAndHold.WinSinceGameStart.TotalWin.InCents));
		
	}


	public Show() {
		this.view.style.display = "block";
	}

	public Hide() {
		this.view.style.display = "none";
	}



	public Update(): void {
		//this.plusOneAnim.Update();
		this.spinAnimation2.Update();
		//this.spinnableReels2.Update();
		//this.bonusAppView.Update();
		//this.transition.Update();

		//this.features.forEach((feature) => feature.Update());

		//this.symbolsAnimation.Update();
		//this.winMessageAnimation.Update();
		//this.shakeAnimation.Update();

		//this.TitleSpriteTransition.Update();
		//this.titleSprite.Update();


		this.holdingFeature.Update();
		this.commetView.Update();
		this.transitionView.Update();

		this.scatterRandomAwardFeature.Update();

		// check canvases
		for (let reelIndex = 0; reelIndex < this.spinnableReels2.canvas.length; reelIndex++)
		{
			for (let rowIndex = 0; rowIndex < this.spinnableReels2.canvas[reelIndex].length; rowIndex++)
			{
				if (this.spinnableReels2.canvas[reelIndex][rowIndex].WasContextLost())
				{
					this.DrawSymbol(reelIndex, rowIndex);

					this.spinnableReels2.canvas[reelIndex][rowIndex].RestoreContext();
				}
			}
		}
		//fix
		// if (this.buttonStartCanvas.WasContextLost() ||
		// 	this.buttonExitCanvas.WasContextLost())
		// {
		// 	this.RedrawCanvasButton();
		// }
	}

	public View(): HTMLElement {
		return this.view;
	}

	public GetSession(): GameSession {
		return this.session;
	}

	/**
	 *	Internal states
	**/
	protected HideAllContainers() {
		this.containers.forEach((container, key) => container.style.display = "none");
	}

	protected ShowContainer(container: SpinAndHoldContainer): void {
		// Log.Debug(this.logGroup, "Showing container " + SpinAndHoldContainer[container]);

		let htmlElement = this.containers.get(container);
		if (htmlElement != null) {
			htmlElement.style.display = "block";

		}
		else {
			Log.Error(this.logGroup, "Container does not exist: " + SpinAndHoldContainer[container]);
		}
	}


	private HideContainer(container: SpinAndHoldContainer): void {
		// Log.Debug(this.logGroup, "Showing container " + SpinAndHoldContainer[container]);

		let htmlElement = this.containers.get(container);
		if (htmlElement != null) {
			htmlElement.style.display = "none";

		}
		else {
			Log.Error(this.logGroup, "Container does not exist: " + SpinAndHoldContainer[container]);
		}
	}

	protected started:boolean=false;
	
	public ShowVideoTransition() {
		if (this.started == false) {
			this.transitionView.ShowTransiton();
			this.started = true;
		}
	}

	

	protected OnTransitionStarted() {
		this.started = true;
	}

	protected OnTransitionEnded(): void {
		this.started = false;
		if (this.stateMachine.State() == SpinAndHoldState.FinalMessage) {
			this.stateMachine.ChangeState(SpinAndHoldState.Idle);
		} else {
			this.stateMachine.ChangeState(SpinAndHoldState.IntroMessage);
		}
	}

    protected OnIntroTransitionBegin(): void
    {
		this.HideAllContainers();
		//this.ShowContainer(SpinAndHoldContainer.IntroMessage);
		//this.ShowContainer(SpinAndHoldContainer.Reels);
		//this.dialogContainerApp.visible = true;
		this.holdingFeature.View().style.display = "block";
		this.PanelRequired(true);
    }

    protected OnIntroTransitionEnd(): void
    {

    }

	protected OnIntroMessageBegin(): void {
		this.robotPlay.BonusConfirm("IntroMessage");
	}

	private OnIntroMessageEnd(): void {
		//this.introMessageContainer.style.display = "none";
		this.robotPlay.BonusConfirmAccepted();
	}

	public OnPicked(index: number): void {
	}

	protected triggerStartSoundLoop: ITimeout;
	protected introStartSound: ITimeout;
	public override TriggerAnimationStartedSprite(): void {		
		let delay: number = 1000;
		for (let i = 0; i < 3; i++) {
			setTimeout(() => this.audio.Play(this.resid.ScopedResourceName("triggered")), delay * (i + 1));
		}
	}

	
	public override BackGroundTransition(): void {		
		this.audio.Play(this.resid.ScopedResourceName("intro"));				
	}

	private OnWaitFirstSpinBegin(): void {
		//this.HideAllContainers();
		//this.ShowContainer(SpinAndHoldContainer.Reels);
		//this.HideContainer(SpinAndHoldContainer.IntroMessage);	
		//this.dialogContainerApp.visible = false;	
		this.messageContainerApp.visible = false;
		this.introMessageContainerApp.visible = false;
		this.timeoutAutoSpin.Start();
	}

	protected OnSpinBegin(): void {
		this.session.RunsRemaining--;
		this.session.RunsPlayed++;

		this.audio.Play(this.parentresid.ScopedResourceName("leverpull"));

		this.screenProtocol?.Send(new SpinAndHoldMessages.SpinMessage(this.session), this.screenProtocolScope);
		this.OnSimpleSpinRunResult();
	}

	

	private OnReelStopped(): void {
		//this.grayScale.Start(reelIndex);
		this.audio.Play(this.parentresid.ScopedResourceName("reelstop"));
	}

	private OnSpinEnd(): void {
		this.audio.Stop(this.parentresid.ScopedResourceName("leverpull"));
		this.session.HoldReels = this.simpleLastBonusAction.HoldReels;
	}

	//protected currentFeature: SlotFeature = null;



	protected OnFeaturesBegin(): void {
		// do we have any features that triggered?

		this.session.RunsRemaining = this.simpleLastBonusAction.SpinsRemaining;
		this.session.RunsPlayed = this.simpleLastBonusAction.SpinsPlayed;
		let ScatterRandomAward = this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult
		this.session.ScattersDisplayed = ScatterRandomAward.ScattersTotal;
		//this.currentFeature = null;
		
		if (ScatterRandomAward.ScattersAddedThisSpin > 0) {
			this.holdingFeature.Start(ScatterRandomAward.ScattersPositionThisSpin);			
			this.timeoutSRAPlusOne.Start();
		}
		else {
			this.stateMachine.ChangeState(SpinAndHoldState.BigWin);
		}
	}

	protected RequestFeatureStop(): void {
		// if (this.currentFeature != null) {
		// 	this.currentFeature.RequestStop();
		// 	//this.symbolsAnimation.Update();
		// }
	}

	protected OnFeaturesEnd(): void {
		//this.currentFeature = null;
		this.HideHoldingReels();
	}



	// public FeatureFinished() {
	// 	// next feature, or continue to big win
	// 	this.currentFeatureIndex++;

	// 	if (this.currentFeatureIndex >= this.lastSpinResult.FeatureResults.length) {
	// 		this.stateMachine.ChangeState(SpinAndHoldState.BigWin);
	// 	}
	// 	else {

	// 		for (; this.currentFeatureIndex < this.lastSpinResult.FeatureResults.length; this.currentFeatureIndex) {
	// 			if (this.lastSpinResult.FeatureResults[i].)
	// 		}
	// 	}
	// }

	private OnBigWinBegin(): void {


		//// Log.Debug(this.logGroup, "Big win message will not show");
		//this.stateMachine.ChangeState(SpinAndHoldState.Win);
		this.stateMachine.ChangeState(SpinAndHoldState.Win);

	}

	private OnBigWinEnd(): void {
	}


	private OnWinBegin(): void {
		this.stateMachine.ChangeState(SpinAndHoldState.Collect);
	}


	private OnWinEnd(): void {
	}

	// private OnLinesComplete(interrupted: boolean): void {
	// 	//this.winLineMarkers.Hide();
	// 	this.stateMachine.ChangeState(SpinAndHoldState.Collect);
	// }

	protected OnCollectBegin(): void {

		this.stateMachine.ChangeState(SpinAndHoldState.SpinIdle);
		//this.screenProtocol?.Send(new FreegameMessages.WinInterruptedMessage(), this.screenProtocolScope);
		//this.indexsimpleLastSpinAction++;
		this.panel.SetMessage(this.translator.t.goodluck);
	}

	public NextBonusEnd() 
	{
		throw "Not implemented"

		// if(this.lastSpinResult.NextBonus != null)
		// {
		// 	this.lastSpinResult.TotalWin += bonusWin;

		// 	this.session.win = bonusWin;
		// 	this.session.totalWin = this.lastSpinResult.TotalWin;
		// 	this.session.winDuration = 1;
		// 	this.panel.SetWin(this.moneyFormatter.FormatCredit(this.lastSpinResult.TotalWin), this.moneyFormatter.FormatCurrency(this.lastSpinResult.TotalWin));
		// 	this.screenProtocol?.Send(new FreegameMessages.WinMessage(this.session),this.screenProtocolScope);

		// 	this.stateMachine.ChangeState(SpinAndHoldState.SpinIdle);
		// }
		// else
		// {
		// 	Log.Error(this.logGroup, "no next bonus");
		// }


	}


	protected OnSpinIdleBegin(): void
	{

		this.panel.OnIdleBegin();

		if (this.session.RunsRemaining > 0)
		{
			// TODO this bonus must auto spin
			// // put some delay before next spin
			if (this.spinInterrupted)
			{
				this.AutoSpin();
			}
			else
			{
				this.autoSpinTimer = window.setTimeout(() => this.AutoSpin(), 1000);
			}
		}
		else
		{
			// put some delay before final message
			this.screenProtocol?.Send(new SpinAndHoldMessages.StartShowWin2Screen, this.screenProtocolScope);			
			this.timeoutStartCometCollect.Start();
		}
	}

	
	protected StartShowWin(jp: JackpotLevel, timerShow: number) {
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		let video: MyVideo = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add(jp));
		video.View().style.display = "";
		video.Play(this.resid);
		TweenLite.set(video.View(), { autoAlpha: 1 });

		SlotGameType1Shared.Instance().jackpotFountain.get(jp)?.Start(this.resid);

		this.audio.Play(this.resid.ScopedResourceName(jp + "Background"));
		this.audio.Play(this.resid.ScopedResourceName(jp + "Voice"));		

		//video show intervals
		this.intervalvideoFadeOutTimer = this.systemContext.TimingContext().CreateTimeout("JP3ShowTime", timerShow, () => {			
			TweenLite.to(video.View(), 1, {
				autoAlpha: 0, onComplete: () => {
					video.StopAndReset(this.resid)
					video.View().style.display = "none";
					this.audio.Stop(this.resid.ScopedResourceName(jp + "Background"));
					this.audio.Stop(this.resid.ScopedResourceName(jp+ "Voice"));
					video = null;									
				}
			});
		});
		this.intervalvideoFadeOutTimer.Start();

		this.intervalStopFountainTimer = this.systemContext.TimingContext().CreateTimeout("JP3ShowTime", timerShow - 500, () => this.StopFontain(jp))
		this.intervalStopFountainTimer.Start();		
	}

	protected StopFontain(jp: JackpotLevel) {
		this.audio.PlayLoop(this.resid.ScopedResourceName("background"));
		SlotGameType1Shared.Instance().jackpotFountain.get(jp)?.RequestStop(this.resid);
	}


	private OnSpinIdleEnd(): void {
		this.panel.Stop();
		//console.log('lastIndex:',this.indexsimpleLastSpinAction)
		this.indexsimpleLastSpinAction++;
		//console.log('nextIndex:',this.indexsimpleLastSpinAction)

	}

	protected OnCometCollectBegin(): void {
		this.currentScatterCometIndex = -1;

		let ScatterAwards = this.simpleEndSpinAction;
		
		this.scatterPositions = ScatterAwards.Awards;
		this.scatterPositions = this.scatterPositions.sort((a, b) => {

            if (a.AwardOptionPosition.Row > b.AwardOptionPosition.Row) return 1;
			if (a.AwardOptionPosition.Row < b.AwardOptionPosition.Row) return -1;

			if (a.AwardOptionPosition.Col > b.AwardOptionPosition.Col) return 1;
			if (a.AwardOptionPosition.Col < b.AwardOptionPosition.Col) return -1;

			return 0;
		});

		// add full award to the beginning, so it starts first
		if (ScatterAwards.FullAward)
		{
			this.scatterPositions.unshift({
				AwardOptionPosition: {
					AwardOption: ScatterAwards.FullAward.AwardOption,
					Col: -1,
					Reel: -1,
					ReelOffset: -1,
					ReelPosition: -1,
					Row: -1,
					ColSpan : -1,
					RowSpan : -1,
				},
				Value: ScatterAwards.FullAward.Value
			});
		}		
		//this.NextComet();
		let jackpotsToReset = this.simpleEndSpinAction.WinAmounts.SequentialProgressiveNonProgressiveWins.map(w => w.Level).filter((p,i,arr)=>arr.indexOf(p) == i);
		this.screenProtocol?.Send(new JackpotValuesReset(jackpotsToReset), new ScreenProtocolScope(["SlotGame", this.gameName]));
		this.timeoutNextCommetCash.Start();
	}

	protected SendWinInfo(win: number) {
		this.screenProtocol?.Send(new SpinAndHoldMessages.WinValue(win), this.screenProtocolScope);		
	}

	protected NextComet() 
	{
		this.InternalNextComet();
	}

	protected InternalNextComet() 
	{
		//this.isShowed = true;
		this.currentScatterCometIndex++;
		if (this.currentScatterCometIndex >= this.scatterPositions.length)
		{
			// Log.Debug(this.logGroup, "Comets complete");			
			this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.simpleConfigSpinAndHold.WinSinceGameStart.TotalWin.InCents), service.moneyFormatter.FormatCurrency(this.simpleConfigSpinAndHold.WinSinceGameStart.TotalWin.InCents))				
			this.timeoutFinalMessageState.Start();					
		}
		else {
			if (SpinAndHoldState.CometCollect == this.stateMachine.State()) {
				this.isShowed = false;
				this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex]);
			}
		}
	}

	protected DesinationComet():Point
	{
		 let destination: Point = TranslateScreen2To1(new Rect(0, 0, Scale.W(1920), Scale.H(1080))).Center();
		return destination
	}

	protected commetInProgress: number = -1;
	protected CometShowtime(awardOptionPosition: AwardPositionWithValue)
	{


		console.log(`CometShowtime index ${this.currentScatterCometIndex}/${this.scatterPositions.length}`, awardOptionPosition);
		this.commetInProgress = this.currentScatterCometIndex;

		// destination is center of top screen?
		//let destination: Point = TranslateScreen2To1(new PixelRect(0, 0, 1920, 1080)).Center();
		
		// start comet, if position exists?
		if (awardOptionPosition.AwardOptionPosition.Reel != -1 && awardOptionPosition.AwardOptionPosition.ReelOffset != -1)
		{
			// Log.Debug(this.logGroup, `Showing comet ${this.currentScatterCometIndex}/${this.scatterPositions.length}`);

			// source is center of scatter
			let symbolRect = this.spinnableReels2.GetAbsoluteSymbolRectReelRow(awardOptionPosition.AwardOptionPosition.Reel, awardOptionPosition.AwardOptionPosition.ReelOffset);
			let source: Point = symbolRect.Center();

			// destination is center of top screen?
			//let destination: Point = TranslateScreen2To1(new PixelRect(0, 0, 1920, 1080)).Center();
			let destination = this.DesinationComet();
			this.commetView.Start(source, destination);
			this.PlayCometSound()
		}
		else {
			
			let genericAwardOption = awardOptionPosition.AwardOptionPosition.AwardOption;
			if (genericAwardOption.AwardType == AwardType.Jackpot) 
			{				
				this.OnCometEnd();
			}			
		}		
	}
	
	protected PlayCometSound(){		
		this.commetView.PlayCometSound();
	}
	//protected TotalAwards: number = 0;
	protected isShowed = false ;
    protected OnCometEnd(): void
    {
		if (this.commetInProgress == -1)
		{
			console.log("Commet no in progress, can't end");
			return;
		}

        let Awards = this.scatterPositions[this.currentScatterCometIndex];
        let genericAwardOption = Awards?.AwardOptionPosition.AwardOption;
		//let JPAward = this.simpleEndSpinAction.find(b=>b.Phase == "End").WinSinceBonusStart.SequentialProgressiveNonProgressiveWins;
		//let awardJPOption = Awards.AwardOptionPosition.AwardOption;
		
		console.log(`OnCometEnd index ${this.currentScatterCometIndex}/${this.scatterPositions.length}`, genericAwardOption);
		
		
			
		
		// start showtime for cash or jackpot
		if (genericAwardOption.AwardType == AwardType.BetMultiplier ||
			genericAwardOption.AwardType == AwardType.Credit
		) {
			this.SendWinInfo(Awards.Value.InCents);
			this.timeoutNextCommetCash.Start();
			this.isShowed = true;
		}
		else if (genericAwardOption.AwardType == AwardType.Jackpot) {
			let awardJPOption = Awards.AwardOptionPosition.AwardOption as JackpotAwardOption;
			if (awardJPOption.JackpotName == JackpotLevel.Jp4) {
				this.timeoutJP4ShowTime.Start();
				this.timeoutNextCommetJP4.Start();
				this.audio.Play(this.resid.ScopedResourceName("clasploop"));
				//this.simpleEndSpinAction

			    void service.api.jpShowStart({
					jackpotName: JackpotLevel.Jp4,
					duration: 55000,
					win: Awards.Value.InCents,
				});

				this.SendWinInfo(Awards.Value.InCents);
				this.isShowed = true;
			}
			else if (awardJPOption.JackpotName == JackpotLevel.Jp3) {				
				this.timeoutJP3ShowTime.Start();
				this.timeoutNextCommetJP3.Start();
				this.SendWinInfo(Awards.Value.InCents);
				this.isShowed = true;
			}
			else if ([JackpotLevel.Jp1, JackpotLevel.Jp2].includes(awardJPOption.JackpotName as JackpotLevel)) {				
				this.timeoutJP2AndJP1ShowTime.Start();
				this.timeoutNextCommetJP1AndJP2.Start();
				this.SendWinInfo(Awards.Value.InCents);
				this.isShowed = true;
			}
			else {
				throw `SpinAndHold CometShowtime unknown jackpot ${awardJPOption.JackpotName}`;
			}
		}

		this.commetInProgress = -1;
	}

	protected OnCometCollectEnd(): void {
		//stops all intervals commets
		//this.RequestStopsCommetShowWin();
	}

	protected RequestStopsCommetShowWin() {
		// Log.Debug(this.logGroup, "Spin: Request stops commets");		
		this.commetView.StopsCommets()			
		this.commetView.StopCometSound();
		// this.timeoutNextCommetJP1AndJP2.Stop();
		// this.timeoutNextCommetJP3.Stop();
		// this.timeoutNextCommetJP4.Stop();
		// this.timeoutJP4ShowTime.Stop();
		// this.timeoutJP3ShowTime.Stop();
		// this.timeoutJP2AndJP1ShowTime.Stop();
		this.timeoutNextCommetCash.Stop();
		// let jp = this.scatterPositions[this.currentScatterCometIndex]?.AwardOptionPosition.AwardOption ;
		// if (jp?.AwardType == AwardType.Jackpot) {
		// 	let video: MyVideo = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add(jp.AwardName));
		// 	video.Stop();			
		// 	this.intervalvideoFadeOutTimer?.Stop();
		// 	this.intervalStopFountainTimer?.Stop();
		// 	video.Hide();
		// 	this.audio.Stop(this.resid.ScopedResourceName(jp.AwardName + "Background"));
		// 	this.audio.Stop(this.resid.ScopedResourceName(jp.AwardName + "Voice"));
		// 	SlotGameType1Shared.Instance().jackpotFountain.get(jp.AwardName as JackpotLevel)?.RequestStop(this.resid);
		// 	video = null;			
		// }				
		//this.stateMachine.ChangeState(SpinAndHoldState.FinalMessage);
		
	}

	protected OnFinalMessageBegin(): void {
		//MOVE POSITIONnextCommetCash
		//this.holdingFeature.Stop();
		this.audio.PlayLoop(this.resid.ScopedResourceName("final"));
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		this.screenProtocol?.Send(new SpinAndHoldMessages.StartBounceFinalBonus, this.screenProtocolScope);
		// let spinEndAction = this.simpleEndSpinAction.find(b=>b.Phase == "End");
		this.params.clientState.SetWin(this.simpleEndSpinAction.WinSinceGameStart.TotalWin.InCents, "TotalBonus Win")
		this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.params.clientState.Win), service.moneyFormatter.FormatCurrency(this.params.clientState.Win));
		this.messageContainerApp.visible = true;
		this.finalMessageContainerApp.visible = true;
		this.finalMessageContainerApp.interactiveChildren = true;	
		this.finalMessageContainerApp.interactive = true;		
		//this.ShowContainer(SpinAndHoldContainer.FinalMessage);		
		this.CreateTransitionPixi(this.gameViewApp);
		//this.VoicePlay = true;		
		this.robotPlay.BonusConfirm("FinalMessage");		
	}

	// protected ClearDataIntervals(){
	// 	this.nextCommetJP1AndJP2 = null;
	// 	this.nextCommetJP3 = null;
	// 	this.nextCommetJP4 = null;
	// 	this.JP4ShowTime = null;
	// 	this.JP3ShowTime = null;
	// 	this.JP2AndJP1ShowTime = null;
	// 	this.nextCommetCash = null;
	// }

	protected OnFinalMessageEnd(): void {
		
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		this.audio.Stop(this.resid.ScopedResourceName("final"));
		this.audio.Play(this.resid.ScopedResourceName("backgroundend"));
		this.OnBonusFinished();
		//this.transition.Start();
		this.robotPlay.BonusConfirmAccepted();
		//this.VoicePlay = true;
		//this.plusOneAnim.Hide();
		this.screenProtocol?.Send(new SpinAndHoldMessages.StopBounceFinalBonus, this.screenProtocolScope);
		
		this.holdingFeature.Stop();
		this.holdingFeature.Hide();		
	}

	/**
	 *	External messages
	**/
	public OnBonusPickElement(pickElement: BonusPickElement): void {
		throw "Not implemented"
	}

	public OnBonusPickReveal(pickReveal: BonusPickReveal): void {
		throw "Not implemented"
	}

	public OnBonusRevealRemaining(revealRemaining: BonusRevealRemaining): void {
		throw "Not implemented"
	}

	protected indexsimpleLastSpinAction : number = 0;
	public OnSimpleSpinRunResult(): void {
		
		// this.indexsimpleLastSpinAction++;
		this.simpleLastBonusAction = this.simpleAllBonusSpinAction[this.indexsimpleLastSpinAction]
		// Log.Debug(this.logGroup, "OnSimpleSpinRunResult()", this.simpleLastBonusAction);
		//console.log("lastSpin:",this.simpleLastSpinAction);
		

		//let this.simpleLastBonusAction = runResult.RunResult as any as SpinAndHoldRunResult;
		
		
		
		this.params.clientState.SetWin(this.simpleLastBonusAction.WinAmounts.TotalWin.InCents, `${this.BonusName()} OnSimpleSpinRunResult()`);
		//this.lastSpinResult = this.simpleLastBonusAction;

		let targets: SpinTargetParams[] = [];

		for (let i = 0; i < this.simpleLastBonusAction.SpinWithFeatures.ReelStops.length; i++) {
			// anticipation can't be on the first reel
			let t: SpinTargetParams = {
                position: this.simpleLastBonusAction.SpinWithFeatures.ReelStops[i],
                anticipation:false ,
                firstAnticipationReelIndex : -1
            };
            
			targets.push(t);
		}

		this.spinAnimation2.SetTargets([]);
		this.reelSetMapper2.SetTargets(targets);

		let scatter = this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as unknown as ScatterRandomAwardResults;
		this.scatterRandomAwardFeature.SetAwards(scatter.ScattersPositionThisSpin);

		this.robotPlay.OnSpinStopAvailable();
	}

	public OnBonusRunResult(): void {}

	public OnBonusTotalResult(totalResult: BonusTotalResult): void {
		// Log.Debug(this.logGroup, "OnBonusTotalResult()", totalResult);
	}

	public OnBonusFinish(bonusFinish: BonusFinish): void {
		// Log.Debug(this.logGroup, "OnBonusFinish()", bonusFinish);
	}

	protected bet: SlotGameBet = null;
	//protected startConfig: SpinAndHoldStartConfig ;
	protected simpleAllBonusSpinAction: SpinAndHoldSpinAction[] = [];
	protected simpleLastBonusAction: SpinAndHoldSpinAction;
	protected simpleEndSpinAction: SpinAndHoldEndAction = null ;
	protected simpleConfigSpinAndHold : SpinAndHoldStartAction;
	public Prepare(bonusStartConfig: IBonusStartConfig): void
	{

		//const spinAndHoldStartConfig: SpinAndHoldStartConfig = bonusStartConfig as any as SpinAndHoldStartConfig;

		// startConfig: ISimpleBonusSpinAction[], bet: SlotGameBet): void {
		// Log.Debug(this.logGroup, "Prepare()", startConfig);

		
		this.simpleAllBonusSpinAction = bonusStartConfig.actions.filter(b=> b.Bonus != "BasegameSpinAction" && b.Phase != "Start" && b.Phase == "Spin") as SpinAndHoldSpinAction[];
		//console.log('AllSpinDataFilter',this.simpleAllBonusSpinAction);
		this.simpleEndSpinAction = bonusStartConfig.actions.find(b=>b.Phase == "End") as SpinAndHoldEndAction;
		this.bet = bonusStartConfig.bet;
		this.scatterRandomAwardFeature.UpdateBet(bonusStartConfig.bet);
		this.scatterRandomAwardFeature.Start();
		this.simpleConfigSpinAndHold = bonusStartConfig.actions.find(b => b.Phase == "Start") as SpinAndHoldStartAction;		
		//this.scatterRandomAwardFeature.SetAwards(this.startConfig.StartingState.FeatureResults.ScatterRandomAward);
		//console.log("ApiResultS&H:",startConfig);
		// Log.Debug(this.logGroup, "Prepare() config: ", this.simpleConfigSpinAndHold);
		// reset targets
		//console.log("config",this.simpleConfigSpinAndHold);
		
		assertNotNullish(this.simpleConfigSpinAndHold, "Start action must exist");
		const reelSet = this.config.MultiReelSets[this.simpleConfigSpinAndHold.ReelSetId];
		assertNotNullish(reelSet, "ReelSet must be loaded");

		let xratio = 1;
		let yratio = 1;

		const extended = this.simpleConfigSpinAndHold.Types.includes(MultiBonusType.Double);
		const rect = extended
			// extended
			? new Rect(Scale.X(115.0) * xratio, Scale.Y(1215) * yratio, Scale.W(1690.0) * xratio, Scale.H(1870.0) * yratio)
			// normal
			: new Rect(Scale.X(74.0) * xratio, Scale.Y(10.0) + (Settings.ScreenHeight * (Settings.Screens - 1)) , Scale.W(1774.0) * xratio, Scale.H(885.0) * yratio);

		this.ConstructReels2({
			PlayWindow: this.simpleConfigSpinAndHold.PlayWindow,
			ReelSet: reelSet,
			WindowRect: rect,
			Extended: extended
		});


		let targets: SpinTargetParams[] = reelSet.map(r => {
            
            let stop: number = 0;
            if (this.simpleConfigSpinAndHold.ReelStops &&
                this.simpleConfigSpinAndHold.ReelStops[r.Index])
            {
                stop = this.simpleConfigSpinAndHold.ReelStops[r.Index];
            }

            return <SpinTargetParams>{
                position: stop,
                anticipation: false,
                firstAnticipationReelIndex: -1,
            };
        });
        
		this.reelSetMapper2.SetTargets(targets, true);




		// redraw reel to apply scatter values
		//this.RedrawAllReels();
		let ScatterRandomAward = this.simpleConfigSpinAndHold.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult;
		//let ScatterRandomAward = this.simpleLastBonusAction.Spin.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult
		if (ScatterRandomAward != null) {
			this.holdingFeature.Start(ScatterRandomAward.ScattersPositionThisSpin);
		}

		// THIS also resets the list from previious bonus
		// saves fresh positions on start
		//this.scatterPositions = this.startConfig.StartingState.FeatureResults.ScatterRandomAward.ScattersPosition;
		this.indexsimpleLastSpinAction = 0;
		this.skipMessageCommets.style.display= "none";
		this.scatterPositions = [];
	}


	public HistoryView(actionIndex: number, gameState: SimpleSlotGameState): HTMLElement {
		//let baseSpinBet: Money = gameState.Bet.TotalBetCents;
		//let gameState: SimpleSlotGameState = JSON.parse(entry2.HistoryGameState.GameState);
		const spin: SpinAndHoldSpinAction = gameState.Actions[actionIndex] as unknown as SpinAndHoldSpinAction;
		const start: SpinAndHoldStartAction = gameState.Actions.slice(0, actionIndex).reverse().find(a => a.Phase == "Start") as SpinAndHoldStartAction;
		const playWindow: PlayWindow = start.PlayWindow;
		const reelSet = this.config.MultiReelSets[start.ReelSetId];
		assertNotNullish(reelSet, "ReelSet must be loaded");
		

		let bonusView: HTMLElement = CreateElement("div", {
			classes: ["bonusView", "SpinAndHoldHistory"],
			style:
			{
				width: "100%",
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "row",
			}
		});

		let reelView: HTMLElement = null;
		let gameView: HTMLElement = CreateElement("div", {
			classes: ["gameBackground"], parentToAppend: bonusView,
			style:
			{
				width: Scale.Wpx(900),
				height: Scale.Hpx(700),
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover",
				backgroundPosition: "center",
				display: "flex",
				flexDirection: "row",
				justifyContent: "center",
				alignItems: "center",
				backgroundImage: this.gameBackground,
			}
		});

		if (spin.Phase == "Spin" || spin.Phase == "Start") {
			console.log(`Scatter positions`, (spin.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPosition);
			// reel view
			reelView = CreateElement("div", {
				classes: ["reelView"], parentToAppend: gameView,
				style:
				{
					width: Scale.Wpx(900),
					height: Scale.Hpx(700),
				}
			});


			let reelTable: HTMLElement = CreateElement("table", { classes: ["reelTable"], parentToAppend: reelView, style: { width: "100%", height: "100%" } });
			for (let i = 0; i < playWindow.Height; i++) {
				let tr: HTMLElement = CreateElement("tr", { classes: ["tr"], parentToAppend: reelTable });

				for (let j = 0; j < playWindow.Width; j++) {

					let coulmnWidth: number = 100 / playWindow.Width;
					let rowHeigt: number = 100 / playWindow.Height;
					let reel = reelSet.find((r) => r.Row == i && r.Col == j);
					if (reel == null) {

					}
					else {
						let td: HTMLTableDataCellElement = CreateElement("td", {
							classes: ["td"], parentToAppend: tr,
							style: {
								//border:"5px solid blue",
								fontSize: Scale.fhpx(80),
								width: "" + (coulmnWidth * reel.ColSpan) + "%",
								height: "" + (rowHeigt * reel.RowSpan) + "%",
							}
						});
						td.colSpan = reel.ColSpan;
						td.rowSpan = reel.RowSpan;

						// TODO what if the action is start action?
						// should just skip it...


						let scatterPosition: AwardOptionPosition = (spin.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPosition.find(s => j == s.Col && i == s.Row);
						console.log(`Checking col ${j} row ${i}: `, scatterPosition);

						if (scatterPosition) {
							//td.innerHTML = ""+scatterPosition.AwardOption.BetMultiplier;
							let award: HTMLElement = CreateElement("div", {
								classes: ["award"], parentToAppend: td,
								style:
								{
									width: "100%",
									height: "100%",
									color: "black",
									display: "flex",
									//backgroundImage: this.historySymbolImg.CssBackground(),
									//backgroundRepeat: "no-repeat",
									//backgroundSize: "cover",
									alignItems: "center",
									justifyContent: "center",
								}
							});

							let img: HTMLElement = CreateElement("div", {
								classes: ["img"], parentToAppend: award,
								style:
								{
									width: "100%",
									height: "75%",
									backgroundImage: this.historySymbolImg.CssBackground(),
									backgroundRepeat: "no-repeat",
									backgroundSize: "contain",
									backgroundPosition: "center",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}
							});

							let value: HTMLElement = CreateElement("div", { classes: ["value"], parentToAppend: img });


							let ValueCanvas = new MyCanvas(new Size(Scale.W((coulmnWidth * reel.ColSpan) * 6), Scale.H((rowHeigt * reel.RowSpan) * 4)));
							ValueCanvas.context.canvas.style.zIndex = "" + ZIndex.BonusWin;
							//add gradient
							//ValueCanvas.context.font = "bold " + 50 + "px " + "NotoSansDisplay-BoldItalic";
							//ValueCanvas.context.fillStyle = "White";
							ValueCanvas.context.textBaseline = "middle";
							ValueCanvas.context.textAlign = "center";
							ValueCanvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
							ValueCanvas.context.miterLimit = 2;
							ValueCanvas.context.shadowBlur = 5;
							ValueCanvas.context.shadowColor = "black";
							//ValueCanvas.context.shadowOffsetX = 8;
							//ValueCanvas.context.shadowOffsetY = 8;
							value.appendChild(ValueCanvas.context.canvas);
							

							this.scatterRandomAwardFeature?.GetHistoryValueCanvas({
								bet: gameState.Bet.Bet,
								scatterPosition: scatterPosition,
								parentElement: ValueCanvas
							});
						}
					}
				}
			}
		}
		else if (spin.Phase == "End") {
			let endAction = gameState.Actions[actionIndex]  as SpinAndHoldEndAction;
			gameView.style.flexDirection= "column";
			let titleBonusWin: HTMLElement = CreateElement("div", {
				classes: ["titleBonusWin"], parentToAppend: gameView,
				style:
				{
					width:"100%",
					height: Scale.Hpx(300),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",					
					fontSize : Scale.fhpx(100),
					color: "white",
					textShadow: `${Scale.XY(10)}px ${Scale.XY(10)}px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,

				}
			});
			titleBonusWin.innerText = " Bonus Win";

			let winView: HTMLElement = CreateElement("div", {
				classes: ["winView"], parentToAppend: gameView,
				style:
				{
					width: "80%",
					height: Scale.Hpx(180),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					backgroundColor : "rgba(0,0,0,0.5)",
					fontSize : Scale.fhpx(100),
					color: "white",	
					textShadow:`0px 0px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,
					borderWidth: Scale.XYpx(5),
					borderStyle: "solid",
					filter: `blur(${Scale.XYpx(2)})`,		
					backgroundImage : "linear-gradient(rgb(0, 0, 0), rgb(22, 22, 206),rgb(0, 0, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",		
				}
			});
			winView.innerText =  service.moneyFormatter.FormatCurrency(endAction.WinSinceGameStart.TotalWin.InCents)
		}

		return bonusView;
	}

	public HistoryStats2(actionIndex: number , gameState: SimpleSlotGameState): ActionStats
	{
		let action: SpinAndHoldSpinAction = gameState.Actions[actionIndex] as SpinAndHoldSpinAction;

		let stats: HistoryStats[] = [];
		if(action.Phase == "Start" || action.Phase =="Spin")
		{
			stats.push({key: "Runs played", value: service.moneyFormatter.FormatQuantity(action.SpinsPlayed)});
			stats.push({key: "Runs remaining", value: service.moneyFormatter.FormatQuantity(action.SpinsRemaining)});
		}

		// find end action
		let endAction: SpinAndHoldEndAction = null;
		for (let i = actionIndex; i < gameState.Actions.length; i++)
		{
			let action = gameState.Actions[i];
			if (action.Bonus != this.bonusName) break;
			if (action.Phase == "End")
			{
				endAction = action as SpinAndHoldEndAction;
				break;
			}
		}

		let revealedScattersCount = 0;
		if (action.Phase == "End")
		{
			revealedScattersCount = endAction.Awards.length;
			
			// full win
			if (endAction.FullAward)
			{
				stats.push({key: "Full screen win:", value: service.moneyFormatter.FormatCurrency(endAction.FullAward.Value.InCents)});
			}
		}
		else
		{
			revealedScattersCount = (action.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersTotal;
		}

		if (!endAction)
		{
			return {
				Bonus: action.Bonus,
				Action: action.Action,
				Stats: stats
			};
		}


		let awards = endAction.Awards.filter((award, index) => index < revealedScattersCount);
		stats.push({key: "Bonus Win:", value: service.moneyFormatter.FormatCurrency(endAction.WinSinceBonusStart.TotalWin.InCents)});
		stats.push({key: "Total Win:", value: service.moneyFormatter.FormatCurrency(endAction.WinSinceGameStart.TotalWin.InCents)});
		


		// jp scatters
		let jpScatters = awards.filter(p => p.AwardOptionPosition.AwardOption.AwardType == AwardType.Jackpot);
		for (let jps of jpScatters)
		{
			// jackpot win
			stats.push({key: `${jps.AwardOptionPosition.AwardOption.AwardName} win:`, value: service.moneyFormatter.FormatCurrency(jps.Value)});
		}
		
		// cash scatters
		let cashScatters = awards.filter(p => 
			p.AwardOptionPosition.AwardOption.AwardType == AwardType.BetMultiplier || 
			p.AwardOptionPosition.AwardOption.AwardType == AwardType.Credit
		);
		if (cashScatters.length > 0)
		{
			let cashScatterWin: number = cashScatters.reduce((total, award) => total + award.Value.InCents, 0);
			stats.push({key: "Cash scatters win:", value: service.moneyFormatter.FormatCurrency(cashScatterWin)});
		}

		return {
			Bonus: action.Bonus,
			Action: action.Action,
			Stats: stats
		};
	}

	public redrawPixiReels() {
		this.ReelBackgroundLoaded();
		this.HideHoldingReels();
		for (let reelIndex = 0; reelIndex < this.spinnableReels2.pixiCanvas.length; reelIndex++) {
			for (let rowIndex = 0; rowIndex < this.spinnableReels2.pixiCanvas[reelIndex].length; rowIndex++) {
				this.DrawSymbol(reelIndex, rowIndex);
			}
		}
		//console.log("PIXI Finish SpinAndHold:", this.gameName);
	}

	//app from base game 
	protected gameViewApp : PIXI.Container = null;
	//main container app bonus 
	protected containerBonusViewApp : PIXI.Container = null;
	public GameSelected(app : PIXI.Container)
	{		
		this.gameViewApp = app;
		//create view main bonus 
		this.containerBonusViewApp = new PIXI.Container();				
		this.containerBonusViewApp.name = "containerBonusViewApp";
		this.containerBonusViewApp.width = Settings.ScreenWidth;
		this.containerBonusViewApp.height = Settings.ScreenHeight * Settings.Screens;
		this.gameViewApp.addChild(this.containerBonusViewApp);
		this.containerBonusViewApp.parent.setChildIndex(this.containerBonusViewApp,1);
		this.spinnableReels2.Create(this.containerBonusViewApp);
		this.CreateContainersPIXIAPP();
	}

	protected introMessageContainerApp: PIXI.Container = null;
	protected finalMessageContainerApp: PIXI.Container = null;
	protected messageContainerApp: PIXI.Container = null;
	protected CreateContainersPIXIAPP(){

		//fix 
		//this.containerBonusViewApp.addChild(this.holdingFeature.GetViewPIXIAPP());
		//this.containerBonusViewApp.parent.setChildIndex(this.holdingFeature.GetViewPIXIAPP(),1)


		//fix stops spinnable reels 
		if (Settings.touchToStop == true) {
			// AddMouseDownListener(this.gameViewApp.view, () => {
			// 	this.spinAnimation2.RequestStop();
			// });
			this.gameViewApp.addEventListener('mousedown', () => this.spinAnimation2.RequestStop());
		}

		this.messageContainerApp  = new PIXI.Container()
		this.messageContainerApp.width = Scale.W(1920);
		this.messageContainerApp.height = Scale.H(1080);
		this.messageContainerApp.x =  0
		this.messageContainerApp.y =  Settings.ScreenHeight * (Settings.Screens-1);
		this.messageContainerApp.name = "messageContainerApp";
		this.containerBonusViewApp.addChild(this.messageContainerApp);

		this.introMessageContainerApp = new PIXI.Container();
		this.introMessageContainerApp.width = Scale.W(1152);
		this.introMessageContainerApp.height = Scale.H(648);
		this.introMessageContainerApp.pivot.set(Scale.W(1152) / 2, Scale.H(648) / 2)
		this.introMessageContainerApp.x = (Scale.W(1920) / 2) - (this.introMessageContainerApp.width / 2)
		this.introMessageContainerApp.y = (Scale.W(1080 / 2) - (this.introMessageContainerApp.height / 2));
		this.introMessageContainerApp.name = "introMessageContainer";
		this.messageContainerApp.addChild(this.introMessageContainerApp);

		let spriteintroSpanishMessageContainerApp = PIXI.Sprite.from(this.textureDialogBonus);		
		spriteintroSpanishMessageContainerApp.width = Scale.W(1152),
		spriteintroSpanishMessageContainerApp.height = Scale.H(648);
		this.introMessageContainerApp.addChild(spriteintroSpanishMessageContainerApp);


		let spriteintroTextureMessageContainerApp = PIXI.Sprite.from( (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusIntro);		
		//spriteintroTextureMessageContainerApp.width = Scale.W(1052),
		//spriteintroTextureMessageContainerApp.height = Scale.H(548);
		spriteintroTextureMessageContainerApp.anchor.set(0.5,0.5);
		spriteintroTextureMessageContainerApp.x =  Scale.W(1152) / 2
		spriteintroTextureMessageContainerApp.y = (Scale.H(648) / 2) - Scale.W(50);
		this.introMessageContainerApp.addChild(spriteintroTextureMessageContainerApp);

		
		

		let buttonIntroContainerApp: PIXI.Container = new PIXI.Container()
		buttonIntroContainerApp.name="buttonIntroContainerApp"
		buttonIntroContainerApp.width = Scale.W(600);
		buttonIntroContainerApp.height = Scale.H(300);
		buttonIntroContainerApp.y = Scale.H(648);
		buttonIntroContainerApp.x = Scale.H(1152) / 2 ;
		buttonIntroContainerApp.pivot.set(Scale.W(600)/2,Scale.H(300)/2);
		buttonIntroContainerApp.interactive = true;
		this.introMessageContainerApp.addChild(buttonIntroContainerApp);

		let spritebuttonIntroContainerApp = PIXI.Sprite.from(this.textureButtonBonus);		
		spritebuttonIntroContainerApp.width = Scale.W(600),
		spritebuttonIntroContainerApp.height = Scale.H(300);

		//create text style
		let textstyle = new PIXI.TextStyle({
            fontFamily: 'NotoSansDisplay-Bold',			
			fontSize: Scale.fh(100),
			//fontStyle: 'italic',
			fontWeight: 'bold',
			fill: ["#F2E416", "#F2BE22" , "#C2760E" , "#F2BE22", "#F2E416" ], // gradient
			stroke: 'black',
			strokeThickness: Scale.fh(10),			
			wordWrap: true,
			wordWrapWidth: Scale.fh(300),
			lineJoin: 'round',
			textBaseline : "middle"
        });
        //this.app.renderer.view.style.position = 'fixed';
       let startTextView = new PIXI.Text(this.translator.t.freegameStart, textstyle);
	   startTextView.x = Scale.W(600) / 2;
	   startTextView.y = Scale.W(300) / 2;	   
	   startTextView.anchor.set(0.5)
	   spritebuttonIntroContainerApp.addChild(startTextView);
        
		//spritebuttonIntroContainerApp.tint = 0xff0000;
		buttonIntroContainerApp.addChild(spritebuttonIntroContainerApp);
		buttonIntroContainerApp.addListener("pointerdown", (ev: MouseEvent) => {
			if (this.stateMachine.State() == SpinAndHoldState.IntroMessage) {
				// Log.Debug(this.logGroup, "Intro message confirmed");
				this.stateMachine.ChangeState(SpinAndHoldState.WaitFirstSpin);				
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + SpinAndHoldState[this.stateMachine.State()] + ", required state: " + SpinAndHoldState[SpinAndHoldState.IntroMessage]);
			}


		});



		//Create Final MessageContainer

		

		this.finalMessageContainerApp = new PIXI.Container();
		this.finalMessageContainerApp.width = Scale.W(1152);
		this.finalMessageContainerApp.height = Scale.H(648);
		this.finalMessageContainerApp.pivot.set(Scale.W(1152) / 2, Scale.H(648) / 2)
		this.finalMessageContainerApp.x = (Scale.W(1920) / 2) - (this.finalMessageContainerApp.width / 2)
		this.finalMessageContainerApp.y = (Scale.W(1080 / 2) - (this.finalMessageContainerApp.height / 2));
		this.finalMessageContainerApp.name = "finalMessageContainerApp";
		this.finalMessageContainerApp.visible = false;
		this.finalMessageContainerApp.interactiveChildren = true;	
		this.finalMessageContainerApp.interactive = true;		
		this.messageContainerApp.addChild(this.finalMessageContainerApp);

		
		let spritefinalSpanishMessageContainerApp = PIXI.Sprite.from(this.textureDialogBonus);		
		spritefinalSpanishMessageContainerApp.width = Scale.W(1152),
		spritefinalSpanishMessageContainerApp.height = Scale.H(648);
		this.finalMessageContainerApp.addChild(spritefinalSpanishMessageContainerApp);


		let spritefinalTextureMessageContainerApp = PIXI.Sprite.from( (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusFinal);		
		//spritefinalTextureMessageContainerApp.width = Scale.W(1052),
		//spritefinalTextureMessageContainerApp.height = Scale.H(548);
		spritefinalTextureMessageContainerApp.anchor.set(0.5,0.5);
		spritefinalTextureMessageContainerApp.x =  Scale.W(1152) / 2
		spritefinalTextureMessageContainerApp.y = (Scale.H(648) / 2) - Scale.W(50);
		this.finalMessageContainerApp.addChild(spritefinalTextureMessageContainerApp);

		

		let finalbuttonIntroContainerApp: PIXI.Container = new PIXI.Container()
		finalbuttonIntroContainerApp.name="finalbuttonIntroContainerApp"
		finalbuttonIntroContainerApp.width = Scale.W(600);
		finalbuttonIntroContainerApp.height = Scale.H(300);
		finalbuttonIntroContainerApp.y = Scale.H(648);
		finalbuttonIntroContainerApp.x = Scale.H(1152) / 2 ;
		finalbuttonIntroContainerApp.pivot.set(Scale.W(600)/2,Scale.H(300)/2);
		finalbuttonIntroContainerApp.interactive = true;
		finalbuttonIntroContainerApp.interactiveChildren = true;
		
		this.finalMessageContainerApp.addChild(finalbuttonIntroContainerApp);

		let spritebuttonFinalContainerApp = PIXI.Sprite.from(this.textureButtonBonus);		
		spritebuttonFinalContainerApp.width = Scale.W(600),
		spritebuttonFinalContainerApp.height = Scale.H(300);
		//spritebuttonFinalContainerApp.tint = 0xff0000;
		finalbuttonIntroContainerApp.addChild(spritebuttonFinalContainerApp);	

		let finalTextView = new PIXI.Text(this.translator.t.freegameExit, textstyle);
		finalTextView.x = Scale.W(600) / 2;
		finalTextView.y = Scale.W(300) / 2;
		finalTextView.anchor.set(0.5)
		spritebuttonFinalContainerApp.addChild(finalTextView);

		finalbuttonIntroContainerApp.addListener("pointerdown", (ev: MouseEvent) => {			
			 if (this.stateMachine.State() == SpinAndHoldState.FinalMessage) {
				this.Spin();
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + SpinAndHoldState[this.stateMachine.State()] + ", required state: " + SpinAndHoldState[SpinAndHoldState.IntroMessage]);
			}
		});

		this.translator.SetOnLanguageChangedCallback(() => {				
			spriteintroTextureMessageContainerApp.texture = (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusIntro;
			spritefinalTextureMessageContainerApp.texture = (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusFinal;	
			startTextView.text = this.translator.t.freegameStart;
			finalTextView.text = this.translator.t.freegameExit;
		});	
	}

	public GameExit()
	{
		this.spinnableReels2.Destroy();
		//this.bonusAppView.Destroy();
	}
	public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
		this.reelSpinAnimations.forEach(animation => {
			animation.UpdateSpinSpeed(changeSpeedParams.SpinParams)
		});
		this.commetView.UpdateCometAnimation(changeSpeedParams.CelebrationFactor)
	}
	public override SharedJackpotWin() {		
		//this.jackpotSharedShow?.Show();		
	}
}


export interface IAwardPositionWithValue
{
	AwardOptionPosition: IAwardOptionPosition;
	Value: Money;
}

export interface IAward
{
	AwardOption: IAwardOption;
	Value: Money;
}

export interface IAwardOptionPosition
{
	Row: number;
	Col: number;
	Reel: number;
	RowSpan: number;
	ColSpan: number;
	ReelOffset: number;
	ReelPosition: number;
	AwardOption: IAwardOption;
}

export interface IAwardOption
{
	AwardType: string;
	AwardName: string;
	JackpotName: string;
	BetMultiplier: number;
}

